/* tslint:disable */
/* eslint-disable */
/**
 * Raven MarketView Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

import { LoadingState } from '../../Types';

/**
 * 
 * @export
 * @interface AddCommodityManagementSiteResponse
 */
export interface AddCommodityManagementSiteResponse {
    /**
     * 
     * @type {CommodityManagementSiteModel}
     * @memberof AddCommodityManagementSiteResponse
     */
    'site'?: CommodityManagementSiteModel;
}
/**
 * 
 * @export
 * @interface AddCompanyRequest
 */
export interface AddCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof AddCompanyRequest
     */
    'name': string;
    /**
     * 
     * @type {Array<MarketViewApplication>}
     * @memberof AddCompanyRequest
     */
    'marketViewApplications'?: Array<MarketViewApplication> | null;
    /**
     * 
     * @type {Array<CompanyProductAccessEntryModel>}
     * @memberof AddCompanyRequest
     */
    'productAccess'?: Array<CompanyProductAccessEntryModel> | null;
}
/**
 * 
 * @export
 * @interface AddCompanyResponse
 */
export interface AddCompanyResponse {
    /**
     * 
     * @type {CompanyModel}
     * @memberof AddCompanyResponse
     */
    'company'?: CompanyModel;
}
/**
 * 
 * @export
 * @interface AddMarketViewSavedQueryResponse
 */
export interface AddMarketViewSavedQueryResponse {
    /**
     * 
     * @type {MarkItViewSavedQueryModel}
     * @memberof AddMarketViewSavedQueryResponse
     */
    'savedQuery'?: MarkItViewSavedQueryModel;
}
/**
 * 
 * @export
 * @interface AddMarketViewUserFavoritedProductRequest
 */
export interface AddMarketViewUserFavoritedProductRequest {
    /**
     * 
     * @type {number}
     * @memberof AddMarketViewUserFavoritedProductRequest
     */
    'productId': number;
}
/**
 * 
 * @export
 * @interface AddMarketViewUserRequest
 */
export interface AddMarketViewUserRequest {
    /**
     * 
     * @type {string}
     * @memberof AddMarketViewUserRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AddMarketViewUserRequest
     */
    'stoneXUserGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddMarketViewUserRequest
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddMarketViewUserRequest
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddMarketViewUserRequest
     */
    'companyGuid'?: string | null;
    /**
     * 
     * @type {Array<MarketViewApplication>}
     * @memberof AddMarketViewUserRequest
     */
    'marketViewApplications'?: Array<MarketViewApplication> | null;
    /**
     * 
     * @type {Array<UserSiteAccessAddModel>}
     * @memberof AddMarketViewUserRequest
     */
    'commodityManagementUserSiteAccesses'?: Array<UserSiteAccessAddModel> | null;
}
/**
 * 
 * @export
 * @interface AddMarketViewUserResponse
 */
export interface AddMarketViewUserResponse {
    /**
     * 
     * @type {MarketViewUserModel}
     * @memberof AddMarketViewUserResponse
     */
    'user'?: MarketViewUserModel;
}
/**
 * 
 * @export
 * @interface AddMarketViewVolumeResponse
 */
export interface AddMarketViewVolumeResponse {
    /**
     * 
     * @type {number}
     * @memberof AddMarketViewVolumeResponse
     */
    'volumeId'?: number;
}
/**
 * 
 * @export
 * @interface AgreeToMarketViewTermsAndConditionsRequest
 */
export interface AgreeToMarketViewTermsAndConditionsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AgreeToMarketViewTermsAndConditionsRequest
     */
    'agree': boolean;
    /**
     * 
     * @type {number}
     * @memberof AgreeToMarketViewTermsAndConditionsRequest
     */
    'version'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Application = {
    Demeter: 'Demeter',
    FarmAdvantage: 'FarmAdvantage',
    MyStoneXMobile: 'MyStoneXMobile',
    CommodityManagement: 'CommodityManagement'
} as const;

export type Application = typeof Application[keyof typeof Application];


/**
 * 
 * @export
 * @interface CalculateMatrixRequest
 */
export interface CalculateMatrixRequest {
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixRequest
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof CalculateMatrixRequest
     */
    'startDate': string;
    /**
     * 
     * @type {MatrixStripType}
     * @memberof CalculateMatrixRequest
     */
    'matrixStripType': MatrixStripType;
    /**
     * 
     * @type {MatrixContractSettlement}
     * @memberof CalculateMatrixRequest
     */
    'contractSettlement': MatrixContractSettlement;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixRequest
     */
    'weighted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixRequest
     */
    'innerRange'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixRequest
     */
    'outerRange'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixRequest
     */
    'innerWeight'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixRequest
     */
    'outerWeight'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixRequest
     */
    'yearsBack'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixRequest
     */
    'applyPpi'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixRequest
     */
    'aboveMedian'?: boolean;
    /**
     * 
     * @type {Array<MatrixTerm>}
     * @memberof CalculateMatrixRequest
     */
    'terms'?: Array<MatrixTerm> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CalculateMatrixRequest
     */
    'months'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof CalculateMatrixRequest
     */
    'calculationDate'?: string | null;
    /**
     * 
     * @type {MatrixCalculationType}
     * @memberof CalculateMatrixRequest
     */
    'calculationType'?: MatrixCalculationType;
    /**
     * 
     * @type {Array<number>}
     * @memberof CalculateMatrixRequest
     */
    'selectedYears'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixRequest
     */
    'startMonth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixRequest
     */
    'includeForwardCurve'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixRequest
     */
    'refreshCache'?: boolean;
    /**
     * 
     * @type {Array<MatrixVolumeModel>}
     * @memberof CalculateMatrixRequest
     */
    'volumes'?: Array<MatrixVolumeModel> | null;
}
/**
 * 
 * @export
 * @interface CalculateMatrixResponse
 */
export interface CalculateMatrixResponse {
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixResponse
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CalculateMatrixResponse
     */
    'startDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixResponse
     */
    'applyPpi'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixResponse
     */
    'weighted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixResponse
     */
    'aboveMedian'?: boolean;
    /**
     * 
     * @type {Array<MatrixTermResultModel>}
     * @memberof CalculateMatrixResponse
     */
    'results'?: Array<MatrixTermResultModel> | null;
    /**
     * 
     * @type {Array<MatrixGraphPointModel>}
     * @memberof CalculateMatrixResponse
     */
    'graphPoints'?: Array<MatrixGraphPointModel> | null;
    /**
     * 
     * @type {Array<MatrixYearPriceSeriesModel>}
     * @memberof CalculateMatrixResponse
     */
    'yearPriceSeries'?: Array<MatrixYearPriceSeriesModel> | null;
    /**
     * 
     * @type {Array<MatrixForwardCurveSeriesModel>}
     * @memberof CalculateMatrixResponse
     */
    'forwardCurveSeries'?: Array<MatrixForwardCurveSeriesModel> | null;
}
/**
 * 
 * @export
 * @interface CommodityManagementSiteAccessModel
 */
export interface CommodityManagementSiteAccessModel {
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteAccessModel
     */
    'siteGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteAccessModel
     */
    'marketViewUserGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteAccessModel
     */
    'siteName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommodityManagementSiteAccessModel
     */
    'isSiteManager'?: boolean;
    /**
     * 
     * @type {Array<CommodityManagementUserPermissions>}
     * @memberof CommodityManagementSiteAccessModel
     */
    'permissions'?: Array<CommodityManagementUserPermissions> | null;
}
/**
 * 
 * @export
 * @interface CommodityManagementSiteModel
 */
export interface CommodityManagementSiteModel {
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteModel
     */
    'siteGuid': string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteModel
     */
    'siteName': string;
    /**
     * 
     * @type {CompanyModel}
     * @memberof CommodityManagementSiteModel
     */
    'company': CompanyModel;
    /**
     * 
     * @type {Array<CommodityManagementSiteAccessModel>}
     * @memberof CommodityManagementSiteModel
     */
    'userSiteAccesses': Array<CommodityManagementSiteAccessModel>;
}
/**
 * 
 * @export
 * @interface CommodityManagementSiteUserModel
 */
export interface CommodityManagementSiteUserModel {
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'marketViewUserGuid': string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'stoneXUserGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'lastName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommodityManagementSiteUserModel
     */
    'isAdministrator': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'siteGuid': string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'siteName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommodityManagementSiteUserModel
     */
    'isSiteManager': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommodityManagementSiteUserModel
     */
    'accessDisabled': boolean;
    /**
     * 
     * @type {Array<CommodityManagementUserPermissions>}
     * @memberof CommodityManagementSiteUserModel
     */
    'permissions': Array<CommodityManagementUserPermissions>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CommodityManagementUserPermissions = {
    ManagePosition: 'ManagePosition',
    ValidatePosition: 'ValidatePosition',
    ManageCommodity: 'ManageCommodity',
    ManageBudget: 'ManageBudget',
    ManageAccount: 'ManageAccount',
    ManagePortfolio: 'ManagePortfolio',
    ManageCounterparty: 'ManageCounterparty',
    ManageMarketPrice: 'ManageMarketPrice',
    ManageOrganization: 'ManageOrganization',
    ManageNotes: 'ManageNotes'
} as const;

export type CommodityManagementUserPermissions = typeof CommodityManagementUserPermissions[keyof typeof CommodityManagementUserPermissions];


/**
 * 
 * @export
 * @enum {string}
 */

export const CommodityType = {
    NaturalGas: 'NaturalGas',
    Electricity: 'Electricity',
    Currencies: 'Currencies',
    Fuel: 'Fuel',
    Dairy: 'Dairy',
    Livestock: 'Livestock',
    Fibers: 'Fibers',
    Metals: 'Metals',
    Coffee: 'Coffee',
    Agriculture: 'Agriculture',
    Stocks: 'Stocks',
    Coal: 'Coal',
    Other: 'Other',
    CropBasis: 'CropBasis',
    CarbonAllowance: 'CarbonAllowance',
    EuNaturalGas: 'EUNaturalGas',
    EuElectricity: 'EUElectricity',
    Favorites: 'Favorites'
} as const;

export type CommodityType = typeof CommodityType[keyof typeof CommodityType];


/**
 * 
 * @export
 * @interface CompanyModel
 */
export interface CompanyModel {
    /**
     * 
     * @type {string}
     * @memberof CompanyModel
     */
    'companyGuid': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyModel
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyModel
     */
    'isDisabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof CompanyModel
     */
    'knowRiskEnergyCustomerId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyModel
     */
    'activeUsers': number;
    /**
     * 
     * @type {number}
     * @memberof CompanyModel
     */
    'totalUsers': number;
    /**
     * 
     * @type {Array<MarketViewApplication>}
     * @memberof CompanyModel
     */
    'marketViewApplications': Array<MarketViewApplication>;
    /**
     * 
     * @type {Array<CompanyProductAccessEntryModel>}
     * @memberof CompanyModel
     */
    'productAccess': Array<CompanyProductAccessEntryModel>;
}
/**
 * 
 * @export
 * @interface CompanyProductAccessEntryModel
 */
export interface CompanyProductAccessEntryModel {
    /**
     * 
     * @type {CommodityType}
     * @memberof CompanyProductAccessEntryModel
     */
    'commodityType'?: CommodityType;
    /**
     * 
     * @type {ProductAccessOverrideType}
     * @memberof CompanyProductAccessEntryModel
     */
    'overrideType'?: ProductAccessOverrideType;
    /**
     * 
     * @type {Array<number>}
     * @memberof CompanyProductAccessEntryModel
     */
    'productIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ContractDate
 */
export interface ContractDate {
    /**
     * 
     * @type {number}
     * @memberof ContractDate
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractDate
     */
    'month'?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractDate
     */
    'label'?: string | null;
}
/**
 * 
 * @export
 * @interface ContractDateRange
 */
export interface ContractDateRange {
    /**
     * 
     * @type {number}
     * @memberof ContractDateRange
     */
    'startYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractDateRange
     */
    'startMonth'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractDateRange
     */
    'endYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractDateRange
     */
    'endMonth'?: number;
    /**
     * 
     * @type {ContractDate}
     * @memberof ContractDateRange
     */
    'startContractDate'?: ContractDate;
    /**
     * 
     * @type {ContractDate}
     * @memberof ContractDateRange
     */
    'endContractDate'?: ContractDate;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Currency = {
    Usd: 'USD',
    Cad: 'CAD',
    Eur: 'EUR',
    Aud: 'AUD',
    Fx: 'FX',
    Gbp: 'GBP',
    Brl: 'BRL',
    Nzd: 'NZD',
    Mxn: 'MXN'
} as const;

export type Currency = typeof Currency[keyof typeof Currency];


/**
 * 
 * @export
 * @interface DailyMarketPriceModel
 */
export interface DailyMarketPriceModel {
    /**
     * 
     * @type {number}
     * @memberof DailyMarketPriceModel
     */
    'priceId': number;
    /**
     * 
     * @type {number}
     * @memberof DailyMarketPriceModel
     */
    'productId': number;
    /**
     * 
     * @type {number}
     * @memberof DailyMarketPriceModel
     */
    'symbolId': number;
    /**
     * 
     * @type {string}
     * @memberof DailyMarketPriceModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {number}
     * @memberof DailyMarketPriceModel
     */
    'closePrice': number;
    /**
     * 
     * @type {number}
     * @memberof DailyMarketPriceModel
     */
    'highPrice': number;
    /**
     * 
     * @type {number}
     * @memberof DailyMarketPriceModel
     */
    'lowPrice': number;
    /**
     * 
     * @type {Unit}
     * @memberof DailyMarketPriceModel
     */
    'unit': Unit;
    /**
     * 
     * @type {Currency}
     * @memberof DailyMarketPriceModel
     */
    'currency': Currency;
}
/**
 * 
 * @export
 * @interface DateRangeFilter
 */
export interface DateRangeFilter {
    /**
     * 
     * @type {string}
     * @memberof DateRangeFilter
     */
    'start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateRangeFilter
     */
    'end'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DayOfWeek = {
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday'
} as const;

export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];


/**
 * 
 * @export
 * @interface DecisiveMarketPriceModel
 */
export interface DecisiveMarketPriceModel {
    /**
     * 
     * @type {string}
     * @memberof DecisiveMarketPriceModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {string}
     * @memberof DecisiveMarketPriceModel
     */
    'productName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DecisiveMarketPriceModel
     */
    'contractMonth': number;
    /**
     * 
     * @type {number}
     * @memberof DecisiveMarketPriceModel
     */
    'contractYear': number;
    /**
     * 
     * @type {string}
     * @memberof DecisiveMarketPriceModel
     */
    'expiration'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DecisiveMarketPriceModel
     */
    'closePrice': number;
    /**
     * 
     * @type {number}
     * @memberof DecisiveMarketPriceModel
     */
    'volatility'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DecisiveMarketPriceModel
     */
    'priceType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecisiveMarketPriceModel
     */
    'optionType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DecisiveMarketPriceModel
     */
    'strike'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DecisiveMarketPriceModel
     */
    'delta'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DecisiveMarketPriceModel
     */
    'country'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EmailScheduleFrequency = {
    Daily: 'Daily',
    Weekdays: 'Weekdays',
    Weekly: 'Weekly',
    Monthly: 'Monthly'
} as const;

export type EmailScheduleFrequency = typeof EmailScheduleFrequency[keyof typeof EmailScheduleFrequency];


/**
 * 
 * @export
 * @interface EmailScheduleModel
 */
export interface EmailScheduleModel {
    /**
     * 
     * @type {number}
     * @memberof EmailScheduleModel
     */
    'emailScheduleId': number;
    /**
     * 
     * @type {EmailScheduleSource}
     * @memberof EmailScheduleModel
     */
    'source': EmailScheduleSource;
    /**
     * 
     * @type {number}
     * @memberof EmailScheduleModel
     */
    'sourceId': number;
    /**
     * 
     * @type {string}
     * @memberof EmailScheduleModel
     */
    'siteGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailScheduleModel
     */
    'subject'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmailScheduleModel
     */
    'recipients': Array<string>;
    /**
     * 
     * @type {EmailScheduleFrequency}
     * @memberof EmailScheduleModel
     */
    'frequency': EmailScheduleFrequency;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof EmailScheduleModel
     */
    'dayOfWeek'?: DayOfWeek;
    /**
     * 
     * @type {number}
     * @memberof EmailScheduleModel
     */
    'dayOfMonth'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EmailScheduleModel
     */
    'timeOfDay': string;
    /**
     * 
     * @type {string}
     * @memberof EmailScheduleModel
     */
    'timeZoneId': string;
    /**
     * 
     * @type {boolean}
     * @memberof EmailScheduleModel
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof EmailScheduleModel
     */
    'nextRunAtUtc': string;
    /**
     * 
     * @type {string}
     * @memberof EmailScheduleModel
     */
    'lastRunAtUtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailScheduleModel
     */
    'lastRunError'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EmailScheduleSource = {
    MarketViewSavedQuery: 'MarketViewSavedQuery',
    CommodityManagementReport: 'CommodityManagementReport'
} as const;

export type EmailScheduleSource = typeof EmailScheduleSource[keyof typeof EmailScheduleSource];


/**
 * 
 * @export
 * @interface FileResponse
 */
export interface FileResponse {
    /**
     * 
     * @type {string}
     * @memberof FileResponse
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileResponse
     */
    'fileContents'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileResponse
     */
    'contentType'?: string | null;
}
/**
 * 
 * @export
 * @interface ForecastAveragesModel
 */
export interface ForecastAveragesModel {
    /**
     * 
     * @type {number}
     * @memberof ForecastAveragesModel
     */
    'settlementAverage'?: number;
    /**
     * 
     * @type {number}
     * @memberof ForecastAveragesModel
     */
    'recentAverage'?: number;
    /**
     * 
     * @type {number}
     * @memberof ForecastAveragesModel
     */
    'historicalMedian'?: number;
    /**
     * 
     * @type {number}
     * @memberof ForecastAveragesModel
     */
    'forecastPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ForecastAveragesModel
     */
    'marketPrice'?: number;
}
/**
 * 
 * @export
 * @interface ForecastDecileModel
 */
export interface ForecastDecileModel {
    /**
     * 
     * @type {number}
     * @memberof ForecastDecileModel
     */
    'mean': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastDecileModel
     */
    'median': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastDecileModel
     */
    'min': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastDecileModel
     */
    'max': number;
    /**
     * 
     * @type {Array<ForecastDecileRowModel>}
     * @memberof ForecastDecileModel
     */
    'rows': Array<ForecastDecileRowModel>;
}
/**
 * 
 * @export
 * @interface ForecastDecileRowModel
 */
export interface ForecastDecileRowModel {
    /**
     * 
     * @type {string}
     * @memberof ForecastDecileRowModel
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof ForecastDecileRowModel
     */
    'lowValue': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastDecileRowModel
     */
    'highValue': number;
}
/**
 * 
 * @export
 * @interface ForecastModel
 */
export interface ForecastModel {
    /**
     * 
     * @type {ContractDate}
     * @memberof ForecastModel
     */
    'contractDate': ContractDate;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'marketPrice': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'settlementAverage': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'settlementAverageWeight': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'recentAverage': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'recentAverageWeight': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'historicalMedian': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'historicalMedianWeight': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'forecastPrice': number;
}
/**
 * 
 * @export
 * @interface GetCompanyResponse
 */
export interface GetCompanyResponse {
    /**
     * 
     * @type {CompanyModel}
     * @memberof GetCompanyResponse
     */
    'company'?: CompanyModel;
}
/**
 * 
 * @export
 * @interface GetForecastResponse
 */
export interface GetForecastResponse {
    /**
     * 
     * @type {string}
     * @memberof GetForecastResponse
     */
    'quoteDate'?: string;
    /**
     * 
     * @type {ForecastDecileModel}
     * @memberof GetForecastResponse
     */
    'decileTable'?: ForecastDecileModel;
    /**
     * 
     * @type {ForecastAveragesModel}
     * @memberof GetForecastResponse
     */
    'averages'?: ForecastAveragesModel;
    /**
     * 
     * @type {Array<ForecastModel>}
     * @memberof GetForecastResponse
     */
    'rows'?: Array<ForecastModel> | null;
    /**
     * 
     * @type {number}
     * @memberof GetForecastResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetForecastResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetForecastResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof GetForecastResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetForecastResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface GetForecastWithHistoryResponse
 */
export interface GetForecastWithHistoryResponse {
    /**
     * 
     * @type {ForecastDecileModel}
     * @memberof GetForecastWithHistoryResponse
     */
    'decileTable'?: ForecastDecileModel;
    /**
     * 
     * @type {ForecastAveragesModel}
     * @memberof GetForecastWithHistoryResponse
     */
    'averages'?: ForecastAveragesModel;
    /**
     * 
     * @type {Array<QuoteDateForecast>}
     * @memberof GetForecastWithHistoryResponse
     */
    'rows'?: Array<QuoteDateForecast> | null;
    /**
     * 
     * @type {number}
     * @memberof GetForecastWithHistoryResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetForecastWithHistoryResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetForecastWithHistoryResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof GetForecastWithHistoryResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetForecastWithHistoryResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface GetMarketViewLastQuoteDateResponse
 */
export interface GetMarketViewLastQuoteDateResponse {
    /**
     * 
     * @type {number}
     * @memberof GetMarketViewLastQuoteDateResponse
     */
    'symbolId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetMarketViewLastQuoteDateResponse
     */
    'quoteDate'?: string;
}
/**
 * 
 * @export
 * @interface GetMarketViewUserAuthorizationResponse
 */
export interface GetMarketViewUserAuthorizationResponse {
    /**
     * 
     * @type {MarketViewUserModel}
     * @memberof GetMarketViewUserAuthorizationResponse
     */
    'user'?: MarketViewUserModel;
}
/**
 * 
 * @export
 * @interface GetMarketViewUserResponse
 */
export interface GetMarketViewUserResponse {
    /**
     * 
     * @type {MarketViewUserModel}
     * @memberof GetMarketViewUserResponse
     */
    'user'?: MarketViewUserModel;
}
/**
 * 
 * @export
 * @interface GetTermsAndConditionsResponse
 */
export interface GetTermsAndConditionsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetTermsAndConditionsResponse
     */
    'agreed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTermsAndConditionsResponse
     */
    'asOfDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetTermsAndConditionsResponse
     */
    'version'?: number | null;
}
/**
 * 
 * @export
 * @interface ListCommodityManagementSiteUsersResponse
 */
export interface ListCommodityManagementSiteUsersResponse {
    /**
     * 
     * @type {Array<CommodityManagementSiteUserModel>}
     * @memberof ListCommodityManagementSiteUsersResponse
     */
    'rows'?: Array<CommodityManagementSiteUserModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityManagementSiteUsersResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListCommodityManagementSiteUsersResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListCommodityManagementSiteUsersResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityManagementSiteUsersResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityManagementSiteUsersResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListCommodityManagementSitesResponse
 */
export interface ListCommodityManagementSitesResponse {
    /**
     * 
     * @type {Array<CommodityManagementSiteModel>}
     * @memberof ListCommodityManagementSitesResponse
     */
    'rows'?: Array<CommodityManagementSiteModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityManagementSitesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListCommodityManagementSitesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListCommodityManagementSitesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityManagementSitesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityManagementSitesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListCompaniesResponse
 */
export interface ListCompaniesResponse {
    /**
     * 
     * @type {Array<CompanyModel>}
     * @memberof ListCompaniesResponse
     */
    'rows'?: Array<CompanyModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListCompaniesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListCompaniesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListCompaniesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListCompaniesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListCompaniesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListEmailSchedulesResponse
 */
export interface ListEmailSchedulesResponse {
    /**
     * 
     * @type {Array<EmailScheduleModel>}
     * @memberof ListEmailSchedulesResponse
     */
    'rows'?: Array<EmailScheduleModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListEmailSchedulesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListEmailSchedulesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListEmailSchedulesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListEmailSchedulesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListEmailSchedulesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewContractPricesRequest
 */
export interface ListMarketViewContractPricesRequest {
    /**
     * 
     * @type {Array<MarketViewPriceQuery>}
     * @memberof ListMarketViewContractPricesRequest
     */
    'marketViewPriceQuery'?: Array<MarketViewPriceQuery> | null;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewContractPricesRequest
     */
    'quoteDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListMarketViewContractPricesRequest
     */
    'includeSettled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListMarketViewContractPricesRequest
     */
    'calculateGreeks'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListMarketViewContractPricesRequest
     */
    'resolveToOptionProducts'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListMarketViewContractPricesRequest
     */
    'implyOptionsIfNotFound'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewContractPricesRequest
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewContractPricesRequest
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewContractPricesRequest
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewContractPricesRequest
     */
    'skip'?: number | null;
}
/**
 * 
 * @export
 * @interface ListMarketViewContractPricesResponse
 */
export interface ListMarketViewContractPricesResponse {
    /**
     * 
     * @type {Array<MarketViewPriceModel>}
     * @memberof ListMarketViewContractPricesResponse
     */
    'rows'?: Array<MarketViewPriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewContractPricesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewContractPricesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewContractPricesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewContractPricesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewContractPricesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewCurrencySpotRatesResponse
 */
export interface ListMarketViewCurrencySpotRatesResponse {
    /**
     * 
     * @type {{ [key: string]: { [key: string]: MarketViewSpotPriceModel; }; }}
     * @memberof ListMarketViewCurrencySpotRatesResponse
     */
    'currencyPairToSpotRates'?: { [key: string]: { [key: string]: MarketViewSpotPriceModel; }; } | null;
}
/**
 * 
 * @export
 * @interface ListMarketViewExpirationDatesResponse
 */
export interface ListMarketViewExpirationDatesResponse {
    /**
     * 
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof ListMarketViewExpirationDatesResponse
     */
    'productIdToContractDateToExpiration'?: { [key: string]: { [key: string]: string; }; } | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: MarketViewExpirationDateModel; }; }}
     * @memberof ListMarketViewExpirationDatesResponse
     */
    'productIdToContractDateToExpirationModel'?: { [key: string]: { [key: string]: MarketViewExpirationDateModel; }; } | null;
}
/**
 * 
 * @export
 * @interface ListMarketViewInternalProductsResponse
 */
export interface ListMarketViewInternalProductsResponse {
    /**
     * 
     * @type {Array<MarketViewProductModel>}
     * @memberof ListMarketViewInternalProductsResponse
     */
    'rows'?: Array<MarketViewProductModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewInternalProductsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewInternalProductsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewInternalProductsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewInternalProductsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewInternalProductsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewLastQuoteDateResponse
 */
export interface ListMarketViewLastQuoteDateResponse {
    /**
     * 
     * @type {Array<MarketViewLastQuoteDateModel>}
     * @memberof ListMarketViewLastQuoteDateResponse
     */
    'rows'?: Array<MarketViewLastQuoteDateModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewLastQuoteDateResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewLastQuoteDateResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewLastQuoteDateResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewLastQuoteDateResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewLastQuoteDateResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewPricesResponse
 */
export interface ListMarketViewPricesResponse {
    /**
     * 
     * @type {Array<MarketViewPriceModel>}
     * @memberof ListMarketViewPricesResponse
     */
    'rows'?: Array<MarketViewPriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewPricesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewPricesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewPricesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewPricesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewPricesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewProductTypesResponse
 */
export interface ListMarketViewProductTypesResponse {
    /**
     * 
     * @type {Array<MarketViewProductTypeModel>}
     * @memberof ListMarketViewProductTypesResponse
     */
    'rows'?: Array<MarketViewProductTypeModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewProductTypesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewProductTypesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewProductTypesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewProductTypesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewProductTypesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewProductsResponse
 */
export interface ListMarketViewProductsResponse {
    /**
     * 
     * @type {Array<MarketViewProductModel>}
     * @memberof ListMarketViewProductsResponse
     */
    'rows'?: Array<MarketViewProductModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewProductsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewProductsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewProductsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewProductsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewProductsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewSavedQueryResponse
 */
export interface ListMarketViewSavedQueryResponse {
    /**
     * 
     * @type {Array<MarkItViewSavedQueryModel>}
     * @memberof ListMarketViewSavedQueryResponse
     */
    'rows'?: Array<MarkItViewSavedQueryModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewSavedQueryResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewSavedQueryResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewSavedQueryResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewSavedQueryResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewSavedQueryResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewUsersResponse
 */
export interface ListMarketViewUsersResponse {
    /**
     * 
     * @type {Array<MarketViewUserModel>}
     * @memberof ListMarketViewUsersResponse
     */
    'rows'?: Array<MarketViewUserModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewUsersResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewUsersResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewUsersResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewUsersResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewUsersResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarkItViewQuerySavedParameters
 */
export interface MarkItViewQuerySavedParameters {
    /**
     * 
     * @type {number}
     * @memberof MarkItViewQuerySavedParameters
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof MarkItViewQuerySavedParameters
     */
    'daysToLookback'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarkItViewQuerySavedParameters
     */
    'priceQueryType'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MarkItViewQuerySavedParameters
     */
    'years': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MarkItViewQuerySavedParameters
     */
    'months': Array<number>;
    /**
     * 
     * @type {CommodityType}
     * @memberof MarkItViewQuerySavedParameters
     */
    'commodityType'?: CommodityType;
    /**
     * 
     * @type {number}
     * @memberof MarkItViewQuerySavedParameters
     */
    'productId'?: number | null;
    /**
     * 
     * @type {ContractDate}
     * @memberof MarkItViewQuerySavedParameters
     */
    'startContractDate': ContractDate;
    /**
     * 
     * @type {ContractDate}
     * @memberof MarkItViewQuerySavedParameters
     */
    'endContractDate': ContractDate;
    /**
     * 
     * @type {number}
     * @memberof MarkItViewQuerySavedParameters
     */
    'monthsAhead'?: number | null;
    /**
     * 
     * @type {MatrixSavedParameters}
     * @memberof MarkItViewQuerySavedParameters
     */
    'matrixParameters': MatrixSavedParameters;
}
/**
 * 
 * @export
 * @interface MarkItViewSavedQueryModel
 */
export interface MarkItViewSavedQueryModel {
    /**
     * 
     * @type {number}
     * @memberof MarkItViewSavedQueryModel
     */
    'savedQueryId': number;
    /**
     * 
     * @type {string}
     * @memberof MarkItViewSavedQueryModel
     */
    'name': string;
    /**
     * 
     * @type {Array<MarkItViewQuerySavedParameters>}
     * @memberof MarkItViewSavedQueryModel
     */
    'queriesParameters': Array<MarkItViewQuerySavedParameters>;
    /**
     * 
     * @type {EmailScheduleModel}
     * @memberof MarkItViewSavedQueryModel
     */
    'emailSchedule': EmailScheduleModel;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MarketViewApplication = {
    MarketView: 'MarketView',
    Benchmark: 'Benchmark',
    Deciles: 'Deciles',
    Forecast: 'Forecast',
    HedgePlan: 'HedgePlan',
    TradersDesk: 'TradersDesk',
    EiaNaturalGasStorage: 'EiaNaturalGasStorage'
} as const;

export type MarketViewApplication = typeof MarketViewApplication[keyof typeof MarketViewApplication];


/**
 * 
 * @export
 * @interface MarketViewContractPriceModel
 */
export interface MarketViewContractPriceModel {
    /**
     * 
     * @type {ContractDate}
     * @memberof MarketViewContractPriceModel
     */
    'contractDate': ContractDate;
    /**
     * 
     * @type {number}
     * @memberof MarketViewContractPriceModel
     */
    'price'?: number | null;
}
/**
 * 
 * @export
 * @interface MarketViewExpirationDateModel
 */
export interface MarketViewExpirationDateModel {
    /**
     * 
     * @type {number}
     * @memberof MarketViewExpirationDateModel
     */
    'productId': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewExpirationDateModel
     */
    'contractMonth': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewExpirationDateModel
     */
    'contractYear': number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewExpirationDateModel
     */
    'expiration': string;
    /**
     * 
     * @type {string}
     * @memberof MarketViewExpirationDateModel
     */
    'optionExpiration'?: string | null;
    /**
     * 
     * @type {ContractDate}
     * @memberof MarketViewExpirationDateModel
     */
    'contractDate': ContractDate;
}
/**
 * 
 * @export
 * @interface MarketViewLastQuoteDateModel
 */
export interface MarketViewLastQuoteDateModel {
    /**
     * 
     * @type {number}
     * @memberof MarketViewLastQuoteDateModel
     */
    'symbolId': number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewLastQuoteDateModel
     */
    'quoteDate': string;
}
/**
 * 
 * @export
 * @interface MarketViewPriceModel
 */
export interface MarketViewPriceModel {
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'priceId': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'productId': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'parentProductId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'symbolId': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'contractMonth': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'contractYear': number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewPriceModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {string}
     * @memberof MarketViewPriceModel
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'closePrice': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'highPrice': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'lowPrice': number;
    /**
     * 
     * @type {OptionStyle}
     * @memberof MarketViewPriceModel
     */
    'optionStyle'?: OptionStyle;
    /**
     * 
     * @type {OptionType}
     * @memberof MarketViewPriceModel
     */
    'optionType'?: OptionType;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'strike'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'volatility'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'delta'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'gamma'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'theta'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'vega'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'rho'?: number | null;
    /**
     * 
     * @type {Unit}
     * @memberof MarketViewPriceModel
     */
    'unit': Unit;
    /**
     * 
     * @type {Currency}
     * @memberof MarketViewPriceModel
     */
    'currency': Currency;
    /**
     * 
     * @type {boolean}
     * @memberof MarketViewPriceModel
     */
    'isImpliedOption': boolean;
    /**
     * 
     * @type {ContractDate}
     * @memberof MarketViewPriceModel
     */
    'contractDate': ContractDate;
}
/**
 * 
 * @export
 * @interface MarketViewPriceQuery
 */
export interface MarketViewPriceQuery {
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceQuery
     */
    'productId'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceQuery
     */
    'contractYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceQuery
     */
    'contractMonth'?: number;
    /**
     * 
     * @type {OptionType}
     * @memberof MarketViewPriceQuery
     */
    'optionType'?: OptionType;
    /**
     * 
     * @type {OptionStyle}
     * @memberof MarketViewPriceQuery
     */
    'optionStyle'?: OptionStyle;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceQuery
     */
    'strike'?: number | null;
    /**
     * 
     * @type {ContractDate}
     * @memberof MarketViewPriceQuery
     */
    'contractDate'?: ContractDate;
}
/**
 * 
 * @export
 * @interface MarketViewProductModel
 */
export interface MarketViewProductModel {
    /**
     * 
     * @type {number}
     * @memberof MarketViewProductModel
     */
    'productId': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewProductModel
     */
    'parentProductId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewProductModel
     */
    'symbolId': number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewProductModel
     */
    'name': string;
    /**
     * 
     * @type {CommodityType}
     * @memberof MarketViewProductModel
     */
    'commodityType': CommodityType;
    /**
     * 
     * @type {PriceType}
     * @memberof MarketViewProductModel
     */
    'priceType': PriceType;
    /**
     * 
     * @type {OptionStyle}
     * @memberof MarketViewProductModel
     */
    'optionStyle'?: OptionStyle;
    /**
     * 
     * @type {Unit}
     * @memberof MarketViewProductModel
     */
    'unit': Unit;
    /**
     * 
     * @type {Currency}
     * @memberof MarketViewProductModel
     */
    'currency': Currency;
    /**
     * 
     * @type {boolean}
     * @memberof MarketViewProductModel
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarketViewProductModel
     */
    'hasDailyPrices': boolean;
}
/**
 * 
 * @export
 * @interface MarketViewProductTradingMonthsResponse
 */
export interface MarketViewProductTradingMonthsResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof MarketViewProductTradingMonthsResponse
     */
    'years'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MarketViewProductTradingMonthsResponse
     */
    'months'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface MarketViewProductTypeModel
 */
export interface MarketViewProductTypeModel {
    /**
     * 
     * @type {CommodityType}
     * @memberof MarketViewProductTypeModel
     */
    'commodityType': CommodityType;
}
/**
 * 
 * @export
 * @interface MarketViewQueryCalendarStripAverageResponse
 */
export interface MarketViewQueryCalendarStripAverageResponse {
    /**
     * 
     * @type {Array<MarketViewQuoteDateYearsModel>}
     * @memberof MarketViewQueryCalendarStripAverageResponse
     */
    'rows'?: Array<MarketViewQuoteDateYearsModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryCalendarStripAverageResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewQueryCalendarStripAverageResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewQueryCalendarStripAverageResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryCalendarStripAverageResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryCalendarStripAverageResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewQueryDailyPricesResponse
 */
export interface MarketViewQueryDailyPricesResponse {
    /**
     * 
     * @type {Array<DailyMarketPriceModel>}
     * @memberof MarketViewQueryDailyPricesResponse
     */
    'rows'?: Array<DailyMarketPriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryDailyPricesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewQueryDailyPricesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewQueryDailyPricesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryDailyPricesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryDailyPricesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewQueryForwardCurveResponse
 */
export interface MarketViewQueryForwardCurveResponse {
    /**
     * 
     * @type {string}
     * @memberof MarketViewQueryForwardCurveResponse
     */
    'quoteDate'?: string;
    /**
     * 
     * @type {Array<MarketViewContractPriceModel>}
     * @memberof MarketViewQueryForwardCurveResponse
     */
    'rows'?: Array<MarketViewContractPriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryForwardCurveResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewQueryForwardCurveResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewQueryForwardCurveResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryForwardCurveResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryForwardCurveResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewQueryPriceResponse
 */
export interface MarketViewQueryPriceResponse {
    /**
     * 
     * @type {Array<MarketViewQuoteDateContractsModel>}
     * @memberof MarketViewQueryPriceResponse
     */
    'rows'?: Array<MarketViewQuoteDateContractsModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryPriceResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewQueryPriceResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewQueryPriceResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryPriceResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryPriceResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewQueryRollingMonthAheadResponse
 */
export interface MarketViewQueryRollingMonthAheadResponse {
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryRollingMonthAheadResponse
     */
    'monthsAhead'?: number;
    /**
     * 
     * @type {Array<MarketViewQuoteDatePriceModel>}
     * @memberof MarketViewQueryRollingMonthAheadResponse
     */
    'rows'?: Array<MarketViewQuoteDatePriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryRollingMonthAheadResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewQueryRollingMonthAheadResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewQueryRollingMonthAheadResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryRollingMonthAheadResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryRollingMonthAheadResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewQuerySettlementsResponse
 */
export interface MarketViewQuerySettlementsResponse {
    /**
     * 
     * @type {Array<MarketViewSettlementPriceModel>}
     * @memberof MarketViewQuerySettlementsResponse
     */
    'rows'?: Array<MarketViewSettlementPriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQuerySettlementsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewQuerySettlementsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewQuerySettlementsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQuerySettlementsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQuerySettlementsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewQueryStripAverageResponse
 */
export interface MarketViewQueryStripAverageResponse {
    /**
     * 
     * @type {DateRangeFilter}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'quoteDateRange'?: DateRangeFilter;
    /**
     * 
     * @type {ContractDateRange}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'contractDateRange'?: ContractDateRange;
    /**
     * 
     * @type {Array<MarketViewQuoteDatePriceModel>}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'rows'?: Array<MarketViewQuoteDatePriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewQuoteDateContractsModel
 */
export interface MarketViewQuoteDateContractsModel {
    /**
     * 
     * @type {string}
     * @memberof MarketViewQuoteDateContractsModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {Array<MarketViewContractPriceModel>}
     * @memberof MarketViewQuoteDateContractsModel
     */
    'contractPrices': Array<MarketViewContractPriceModel>;
}
/**
 * 
 * @export
 * @interface MarketViewQuoteDatePriceModel
 */
export interface MarketViewQuoteDatePriceModel {
    /**
     * 
     * @type {string}
     * @memberof MarketViewQuoteDatePriceModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQuoteDatePriceModel
     */
    'price': number;
}
/**
 * 
 * @export
 * @interface MarketViewQuoteDateYearsModel
 */
export interface MarketViewQuoteDateYearsModel {
    /**
     * 
     * @type {string}
     * @memberof MarketViewQuoteDateYearsModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {Array<MarketViewYearPriceModel>}
     * @memberof MarketViewQuoteDateYearsModel
     */
    'yearPrices': Array<MarketViewYearPriceModel>;
}
/**
 * 
 * @export
 * @interface MarketViewSettlementPriceModel
 */
export interface MarketViewSettlementPriceModel {
    /**
     * 
     * @type {string}
     * @memberof MarketViewSettlementPriceModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {ContractDate}
     * @memberof MarketViewSettlementPriceModel
     */
    'contractDate': ContractDate;
    /**
     * 
     * @type {number}
     * @memberof MarketViewSettlementPriceModel
     */
    'price'?: number | null;
}
/**
 * 
 * @export
 * @interface MarketViewSpotPriceModel
 */
export interface MarketViewSpotPriceModel {
    /**
     * 
     * @type {Currency}
     * @memberof MarketViewSpotPriceModel
     */
    'currencyFrom': Currency;
    /**
     * 
     * @type {Currency}
     * @memberof MarketViewSpotPriceModel
     */
    'currencyTo': Currency;
    /**
     * 
     * @type {ContractDate}
     * @memberof MarketViewSpotPriceModel
     */
    'contractDate': ContractDate;
    /**
     * 
     * @type {number}
     * @memberof MarketViewSpotPriceModel
     */
    'conversionRate': number;
}
/**
 * 
 * @export
 * @interface MarketViewUserModel
 */
export interface MarketViewUserModel {
    /**
     * 
     * @type {Array<CommodityManagementSiteAccessModel>}
     * @memberof MarketViewUserModel
     */
    'commodityManagementUserSiteAccesses'?: Array<CommodityManagementSiteAccessModel> | null;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'marketViewUserGuid': string;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'stoneXUserGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'companyGuid'?: string | null;
    /**
     * 
     * @type {CompanyModel}
     * @memberof MarketViewUserModel
     */
    'company': CompanyModel;
    /**
     * 
     * @type {Array<MarketViewApplication>}
     * @memberof MarketViewUserModel
     */
    'marketViewApplications': Array<MarketViewApplication>;
    /**
     * 
     * @type {boolean}
     * @memberof MarketViewUserModel
     */
    'isAdministrator': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarketViewUserModel
     */
    'isDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'userAddedDate': string;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'addedByUserGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'addedByUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'lastAuthorizationTime'?: string | null;
    /**
     * 
     * @type {GetTermsAndConditionsResponse}
     * @memberof MarketViewUserModel
     */
    'getTermsAndConditionsResponse': GetTermsAndConditionsResponse;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'displayName': string;
}
/**
 * 
 * @export
 * @interface MarketViewVolumeModel
 */
export interface MarketViewVolumeModel {
    /**
     * 
     * @type {number}
     * @memberof MarketViewVolumeModel
     */
    'userVolumeId': number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewVolumeModel
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof MarketViewVolumeModel
     */
    'volumes': { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface MarketViewVolumesResponse
 */
export interface MarketViewVolumesResponse {
    /**
     * 
     * @type {Array<MarketViewVolumeModel>}
     * @memberof MarketViewVolumesResponse
     */
    'rows'?: Array<MarketViewVolumeModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewVolumesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewVolumesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewVolumesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewVolumesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewVolumesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewYearPriceModel
 */
export interface MarketViewYearPriceModel {
    /**
     * 
     * @type {number}
     * @memberof MarketViewYearPriceModel
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewYearPriceModel
     */
    'price'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MatrixCalculationType = {
    Monthly: 'Monthly',
    Expiration: 'Expiration'
} as const;

export type MatrixCalculationType = typeof MatrixCalculationType[keyof typeof MatrixCalculationType];


/**
 * 
 * @export
 * @enum {string}
 */

export const MatrixContractSettlement = {
    ExpirationDate: 'ExpirationDate',
    LastDayOfTheMonth: 'LastDayOfTheMonth'
} as const;

export type MatrixContractSettlement = typeof MatrixContractSettlement[keyof typeof MatrixContractSettlement];


/**
 * 
 * @export
 * @interface MatrixForwardCurvePointModel
 */
export interface MatrixForwardCurvePointModel {
    /**
     * 
     * @type {number}
     * @memberof MatrixForwardCurvePointModel
     */
    'contractMonth'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixForwardCurvePointModel
     */
    'contractYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixForwardCurvePointModel
     */
    'price'?: number;
}
/**
 * 
 * @export
 * @interface MatrixForwardCurveSeriesModel
 */
export interface MatrixForwardCurveSeriesModel {
    /**
     * 
     * @type {string}
     * @memberof MatrixForwardCurveSeriesModel
     */
    'term'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixForwardCurveSeriesModel
     */
    'quoteDate'?: string;
    /**
     * 
     * @type {Array<MatrixForwardCurvePointModel>}
     * @memberof MatrixForwardCurveSeriesModel
     */
    'prices'?: Array<MatrixForwardCurvePointModel> | null;
}
/**
 * 
 * @export
 * @interface MatrixGraphPointModel
 */
export interface MatrixGraphPointModel {
    /**
     * 
     * @type {string}
     * @memberof MatrixGraphPointModel
     */
    'calculationDate'?: string;
    /**
     * 
     * @type {Array<MatrixTermResultModel>}
     * @memberof MatrixGraphPointModel
     */
    'terms'?: Array<MatrixTermResultModel> | null;
}
/**
 * 
 * @export
 * @interface MatrixModel
 */
export interface MatrixModel {
    /**
     * 
     * @type {number}
     * @memberof MatrixModel
     */
    'rank'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixModel
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface MatrixPriceModel
 */
export interface MatrixPriceModel {
    /**
     * 
     * @type {string}
     * @memberof MatrixPriceModel
     */
    'quoteDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixPriceModel
     */
    'contractDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof MatrixPriceModel
     */
    'price'?: number;
}
/**
 * 
 * @export
 * @interface MatrixSavedParameters
 */
export interface MatrixSavedParameters {
    /**
     * 
     * @type {number}
     * @memberof MatrixSavedParameters
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MatrixSavedParameters
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixSavedParameters
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixSavedParameters
     */
    'matrixStripType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixSavedParameters
     */
    'contractSettlement'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixSavedParameters
     */
    'terms'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MatrixSavedParameters
     */
    'months'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixSavedParameters
     */
    'startMonth'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixSavedParameters
     */
    'weighted'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixSavedParameters
     */
    'innerRange'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixSavedParameters
     */
    'outerRange'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixSavedParameters
     */
    'innerWeight'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixSavedParameters
     */
    'outerWeight'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixSavedParameters
     */
    'yearsBack'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixSavedParameters
     */
    'applyPpi'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixSavedParameters
     */
    'aboveMedian'?: boolean | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MatrixStripType = {
    FirstContractMonth: 'FirstContractMonth',
    SecondContractMonth: 'SecondContractMonth',
    Strip: 'Strip',
    ContractPeriod: 'ContractPeriod',
    RollingMonth: 'RollingMonth'
} as const;

export type MatrixStripType = typeof MatrixStripType[keyof typeof MatrixStripType];


/**
 * 
 * @export
 * @enum {string}
 */

export const MatrixTerm = {
    Annual: 'Annual',
    Summer: 'Summer',
    Winter: 'Winter',
    FirstQuarter: 'FirstQuarter',
    SecondQuarter: 'SecondQuarter',
    ThirdQuarter: 'ThirdQuarter',
    FourthQuarter: 'FourthQuarter',
    JanuaryFebruary: 'JanuaryFebruary',
    MarchApril: 'MarchApril',
    JulyAugust: 'JulyAugust',
    OctoberDecember: 'OctoberDecember',
    Custom: 'Custom'
} as const;

export type MatrixTerm = typeof MatrixTerm[keyof typeof MatrixTerm];


/**
 * 
 * @export
 * @interface MatrixTermResultModel
 */
export interface MatrixTermResultModel {
    /**
     * 
     * @type {string}
     * @memberof MatrixTermResultModel
     */
    'season'?: string | null;
    /**
     * 
     * @type {Array<MatrixModel>}
     * @memberof MatrixTermResultModel
     */
    'weightedDeciles'?: Array<MatrixModel> | null;
    /**
     * 
     * @type {Array<MatrixModel>}
     * @memberof MatrixTermResultModel
     */
    'innerDeciles'?: Array<MatrixModel> | null;
    /**
     * 
     * @type {Array<MatrixModel>}
     * @memberof MatrixTermResultModel
     */
    'outerDeciles'?: Array<MatrixModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixTermResultModel
     */
    'innerMean'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixTermResultModel
     */
    'outerMean'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixTermResultModel
     */
    'weightedMean'?: number;
    /**
     * 
     * @type {Array<MatrixPriceModel>}
     * @memberof MatrixTermResultModel
     */
    'innerPrices'?: Array<MatrixPriceModel> | null;
    /**
     * 
     * @type {Array<MatrixPriceModel>}
     * @memberof MatrixTermResultModel
     */
    'outerPrices'?: Array<MatrixPriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixTermResultModel
     */
    'innerPriceCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixTermResultModel
     */
    'outerPriceCount'?: number;
}
/**
 * 
 * @export
 * @interface MatrixVolumeModel
 */
export interface MatrixVolumeModel {
    /**
     * 
     * @type {number}
     * @memberof MatrixVolumeModel
     */
    'contractYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixVolumeModel
     */
    'contractMonth'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixVolumeModel
     */
    'volume'?: number;
}
/**
 * 
 * @export
 * @interface MatrixYearPriceDailyModel
 */
export interface MatrixYearPriceDailyModel {
    /**
     * 
     * @type {string}
     * @memberof MatrixYearPriceDailyModel
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof MatrixYearPriceDailyModel
     */
    'price'?: number | null;
}
/**
 * 
 * @export
 * @interface MatrixYearPriceSeriesModel
 */
export interface MatrixYearPriceSeriesModel {
    /**
     * 
     * @type {number}
     * @memberof MatrixYearPriceSeriesModel
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof MatrixYearPriceSeriesModel
     */
    'term'?: string | null;
    /**
     * 
     * @type {Array<MatrixYearPriceDailyModel>}
     * @memberof MatrixYearPriceSeriesModel
     */
    'dailyPrices'?: Array<MatrixYearPriceDailyModel> | null;
    /**
     * 
     * @type {Array<MatrixVolumeModel>}
     * @memberof MatrixYearPriceSeriesModel
     */
    'volumes'?: Array<MatrixVolumeModel> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OptionStyle = {
    American: 'American',
    European: 'European',
    Asian: 'Asian'
} as const;

export type OptionStyle = typeof OptionStyle[keyof typeof OptionStyle];


/**
 * 
 * @export
 * @enum {string}
 */

export const OptionType = {
    Call: 'Call',
    Put: 'Put'
} as const;

export type OptionType = typeof OptionType[keyof typeof OptionType];


/**
 * 
 * @export
 * @enum {string}
 */

export const PriceType = {
    None: 'None',
    Future: 'Future',
    Option: 'Option',
    Physical: 'Physical',
    Basis: 'Basis',
    OnPeakEast: 'OnPeakEast',
    WrapEast: 'WrapEast',
    OnPeakWest: 'OnPeakWest',
    WrapWest: 'WrapWest',
    AroundTheClock: 'AroundTheClock',
    StaticPrice: 'StaticPrice',
    Daily: 'Daily',
    Cm: 'CM',
    Cm1: 'CM1'
} as const;

export type PriceType = typeof PriceType[keyof typeof PriceType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ProductAccessOverrideType = {
    Allow: 'Allow',
    Block: 'Block'
} as const;

export type ProductAccessOverrideType = typeof ProductAccessOverrideType[keyof typeof ProductAccessOverrideType];


/**
 * 
 * @export
 * @interface QuoteDateForecast
 */
export interface QuoteDateForecast {
    /**
     * 
     * @type {string}
     * @memberof QuoteDateForecast
     */
    'quoteDate': string;
    /**
     * 
     * @type {number}
     * @memberof QuoteDateForecast
     */
    'forecastAverage': number;
    /**
     * 
     * @type {number}
     * @memberof QuoteDateForecast
     */
    'forwardAverage': number;
    /**
     * 
     * @type {Array<ForecastModel>}
     * @memberof QuoteDateForecast
     */
    'forecasts': Array<ForecastModel>;
}
/**
 * 
 * @export
 * @interface SendEmailScheduleResponse
 */
export interface SendEmailScheduleResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SendEmailScheduleResponse
     */
    'sent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SendEmailScheduleResponse
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendEmailScheduleResponse
     */
    'nextRunAtUtc'?: string;
}
/**
 * 
 * @export
 * @interface SendMarketViewSavedQueryEmailRequest
 */
export interface SendMarketViewSavedQueryEmailRequest {
    /**
     * 
     * @type {number}
     * @memberof SendMarketViewSavedQueryEmailRequest
     */
    'savedQueryId': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendMarketViewSavedQueryEmailRequest
     */
    'recipients': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SendMarketViewSavedQueryEmailRequest
     */
    'subject'?: string | null;
}
/**
 * 
 * @export
 * @interface SendMarketViewSavedQueryEmailResponse
 */
export interface SendMarketViewSavedQueryEmailResponse {
    /**
     * 
     * @type {string}
     * @memberof SendMarketViewSavedQueryEmailResponse
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendMarketViewSavedQueryEmailResponse
     */
    'quoteDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendMarketViewSavedQueryEmailResponse
     */
    'recipients'?: Array<string> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirection = {
    Asc: 'Asc',
    Desc: 'Desc',
    None: 'None'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];


/**
 * 
 * @export
 * @enum {string}
 */

export const Unit = {
    None: 'None',
    Mmbtu: 'MMBTu',
    Mw: 'MW',
    Ton: 'Ton',
    Tonne: 'Tonne',
    Bbl: 'Bbl',
    Bu: 'Bu',
    Gal: 'Gal',
    Lb: 'Lb',
    Cwt: 'Cwt',
    Sc: 'Sc',
    Contract: 'Contract',
    Kg: 'Kg',
    Lt: 'Lt',
    Mwh: 'MWh',
    Toz: 'Toz',
    Gj: 'Gj',
    KgMs: 'KgMs',
    Allowance: 'Allowance'
} as const;

export type Unit = typeof Unit[keyof typeof Unit];


/**
 * 
 * @export
 * @interface UpdateCommodityManagementSiteResponse
 */
export interface UpdateCommodityManagementSiteResponse {
    /**
     * 
     * @type {CommodityManagementSiteModel}
     * @memberof UpdateCommodityManagementSiteResponse
     */
    'site'?: CommodityManagementSiteModel;
}
/**
 * 
 * @export
 * @interface UpdateCompanyRequest
 */
export interface UpdateCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    'companyGuid': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    'name': string;
    /**
     * 
     * @type {Array<MarketViewApplication>}
     * @memberof UpdateCompanyRequest
     */
    'marketViewApplications'?: Array<MarketViewApplication> | null;
    /**
     * 
     * @type {Array<CompanyProductAccessEntryModel>}
     * @memberof UpdateCompanyRequest
     */
    'productAccess'?: Array<CompanyProductAccessEntryModel> | null;
}
/**
 * 
 * @export
 * @interface UpdateCompanyResponse
 */
export interface UpdateCompanyResponse {
    /**
     * 
     * @type {CompanyModel}
     * @memberof UpdateCompanyResponse
     */
    'company'?: CompanyModel;
}
/**
 * 
 * @export
 * @interface UpdateMarketViewUserRequest
 */
export interface UpdateMarketViewUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMarketViewUserRequest
     */
    'marketViewUserGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMarketViewUserRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMarketViewUserRequest
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMarketViewUserRequest
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMarketViewUserRequest
     */
    'companyGuid'?: string | null;
    /**
     * 
     * @type {Array<MarketViewApplication>}
     * @memberof UpdateMarketViewUserRequest
     */
    'marketViewApplications'?: Array<MarketViewApplication> | null;
    /**
     * 
     * @type {Array<UserSiteAccessUpdateModel>}
     * @memberof UpdateMarketViewUserRequest
     */
    'commodityManagementUserSiteAccesses'?: Array<UserSiteAccessUpdateModel> | null;
}
/**
 * 
 * @export
 * @interface UpdateMarketViewUserResponse
 */
export interface UpdateMarketViewUserResponse {
    /**
     * 
     * @type {MarketViewUserModel}
     * @memberof UpdateMarketViewUserResponse
     */
    'user'?: MarketViewUserModel;
}
/**
 * 
 * @export
 * @interface UpsertEmailScheduleRequest
 */
export interface UpsertEmailScheduleRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertEmailScheduleRequest
     */
    'emailScheduleId'?: number;
    /**
     * 
     * @type {EmailScheduleSource}
     * @memberof UpsertEmailScheduleRequest
     */
    'source': EmailScheduleSource;
    /**
     * 
     * @type {number}
     * @memberof UpsertEmailScheduleRequest
     */
    'sourceId': number;
    /**
     * 
     * @type {string}
     * @memberof UpsertEmailScheduleRequest
     */
    'siteGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertEmailScheduleRequest
     */
    'subject'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertEmailScheduleRequest
     */
    'recipients': Array<string>;
    /**
     * 
     * @type {EmailScheduleFrequency}
     * @memberof UpsertEmailScheduleRequest
     */
    'frequency': EmailScheduleFrequency;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof UpsertEmailScheduleRequest
     */
    'dayOfWeek'?: DayOfWeek;
    /**
     * 
     * @type {number}
     * @memberof UpsertEmailScheduleRequest
     */
    'dayOfMonth'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertEmailScheduleRequest
     */
    'timeOfDay': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertEmailScheduleRequest
     */
    'timeZoneId': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertEmailScheduleRequest
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @interface UpsertEmailScheduleResponse
 */
export interface UpsertEmailScheduleResponse {
    /**
     * 
     * @type {EmailScheduleModel}
     * @memberof UpsertEmailScheduleResponse
     */
    'emailSchedule'?: EmailScheduleModel;
}
/**
 * 
 * @export
 * @interface UserAccessUpdateModel
 */
export interface UserAccessUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof UserAccessUpdateModel
     */
    'marketViewUserGuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccessUpdateModel
     */
    'isSiteManager': boolean;
    /**
     * 
     * @type {Array<CommodityManagementUserPermissions>}
     * @memberof UserAccessUpdateModel
     */
    'permissions': Array<CommodityManagementUserPermissions>;
}
/**
 * 
 * @export
 * @interface UserSiteAccessAddModel
 */
export interface UserSiteAccessAddModel {
    /**
     * 
     * @type {string}
     * @memberof UserSiteAccessAddModel
     */
    'siteGuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSiteAccessAddModel
     */
    'isSiteManager': boolean;
    /**
     * 
     * @type {Array<CommodityManagementUserPermissions>}
     * @memberof UserSiteAccessAddModel
     */
    'permissions': Array<CommodityManagementUserPermissions>;
}
/**
 * 
 * @export
 * @interface UserSiteAccessUpdateModel
 */
export interface UserSiteAccessUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof UserSiteAccessUpdateModel
     */
    'marketViewUserGuid': string;
    /**
     * 
     * @type {string}
     * @memberof UserSiteAccessUpdateModel
     */
    'siteGuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSiteAccessUpdateModel
     */
    'isSiteManager': boolean;
    /**
     * 
     * @type {Array<CommodityManagementUserPermissions>}
     * @memberof UserSiteAccessUpdateModel
     */
    'permissions': Array<CommodityManagementUserPermissions>;
}

/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationHealth: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApplicationHealth(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApplicationHealth(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationHealth(options?: any): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.getApplicationHealth(options).then((request) => request(axios, basePath));
        },
    };
};



/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public getApplicationHealth(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = HealthApiFp(this.configuration).getApplicationHealth(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }
}


/**
 * MarketViewApi - axios parameter creator
 * @export
 */
export const MarketViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} siteName 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommodityManagementSite: async (siteName: string, companyGuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteName' is not null or undefined
            assertParamExists('addCommodityManagementSite', 'siteName', siteName)
            // verify required parameter 'companyGuid' is not null or undefined
            assertParamExists('addCommodityManagementSite', 'companyGuid', companyGuid)
            const localVarPath = `/market-view/commodity-management/sites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (siteName !== undefined) {
                localVarQueryParameter['SiteName'] = siteName;
            }

            if (companyGuid !== undefined) {
                localVarQueryParameter['CompanyGuid'] = companyGuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {string} [email] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {boolean} [isSiteManager] 
         * @param {Array<CommodityManagementUserPermissions>} [permissions] 
         * @param {boolean} [initializeAccessIfNew] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommodityManagementUserSiteAccess: async (siteGuid: string, marketViewUserGuid: string, email?: string, firstName?: string, lastName?: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, initializeAccessIfNew?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteGuid' is not null or undefined
            assertParamExists('addCommodityManagementUserSiteAccess', 'siteGuid', siteGuid)
            // verify required parameter 'marketViewUserGuid' is not null or undefined
            assertParamExists('addCommodityManagementUserSiteAccess', 'marketViewUserGuid', marketViewUserGuid)
            const localVarPath = `/market-view/commodity-management/sites/{siteGuid}/{marketViewUserGuid}`
                .replace(`{${"siteGuid"}}`, encodeURIComponent(String(siteGuid)))
                .replace(`{${"marketViewUserGuid"}}`, encodeURIComponent(String(marketViewUserGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['Email'] = email;
            }

            if (firstName !== undefined) {
                localVarQueryParameter['FirstName'] = firstName;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['LastName'] = lastName;
            }

            if (isSiteManager !== undefined) {
                localVarQueryParameter['IsSiteManager'] = isSiteManager;
            }

            if (permissions) {
                localVarQueryParameter['Permissions'] = permissions;
            }

            if (initializeAccessIfNew !== undefined) {
                localVarQueryParameter['InitializeAccessIfNew'] = initializeAccessIfNew;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddCompanyRequest} [addCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompany: async (addCompanyRequest?: AddCompanyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCompanyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} savedQueryId 
         * @param {string} name 
         * @param {Array<MarkItViewQuerySavedParameters>} markItViewQuerySavedParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewSavedQuery: async (savedQueryId: number, name: string, markItViewQuerySavedParameters: Array<MarkItViewQuerySavedParameters>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'savedQueryId' is not null or undefined
            assertParamExists('addMarketViewSavedQuery', 'savedQueryId', savedQueryId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('addMarketViewSavedQuery', 'name', name)
            // verify required parameter 'markItViewQuerySavedParameters' is not null or undefined
            assertParamExists('addMarketViewSavedQuery', 'markItViewQuerySavedParameters', markItViewQuerySavedParameters)
            const localVarPath = `/market-view/saved-queries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (savedQueryId !== undefined) {
                localVarQueryParameter['SavedQueryId'] = savedQueryId;
            }

            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markItViewQuerySavedParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddMarketViewUserRequest} [addMarketViewUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewUser: async (addMarketViewUserRequest?: AddMarketViewUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addMarketViewUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {AddMarketViewUserFavoritedProductRequest} [addMarketViewUserFavoritedProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewUserFavoritedProduct: async (productId: string, addMarketViewUserFavoritedProductRequest?: AddMarketViewUserFavoritedProductRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('addMarketViewUserFavoritedProduct', 'productId', productId)
            const localVarPath = `/market-view/products/{productId}/favorites`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addMarketViewUserFavoritedProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userVolumeId 
         * @param {string} name 
         * @param {{ [key: string]: number; }} volumes 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewVolume: async (userVolumeId: number, name: string, volumes: { [key: string]: number; }, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userVolumeId' is not null or undefined
            assertParamExists('addMarketViewVolume', 'userVolumeId', userVolumeId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('addMarketViewVolume', 'name', name)
            // verify required parameter 'volumes' is not null or undefined
            assertParamExists('addMarketViewVolume', 'volumes', volumes)
            const localVarPath = `/market-view/volumes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userVolumeId !== undefined) {
                localVarQueryParameter['UserVolumeId'] = userVolumeId;
            }

            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }

            if (volumes !== undefined) {
                localVarQueryParameter['Volumes'] = volumes;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AgreeToMarketViewTermsAndConditionsRequest} [agreeToMarketViewTermsAndConditionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreeToDemeterTermsAndConditions: async (agreeToMarketViewTermsAndConditionsRequest?: AgreeToMarketViewTermsAndConditionsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/users/terms-and-conditions/agree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agreeToMarketViewTermsAndConditionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CalculateMatrixRequest} [calculateMatrixRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateMatrix: async (calculateMatrixRequest?: CalculateMatrixRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/matrix/calculate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculateMatrixRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {boolean} [disableUserIfNoOtherSites] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommodityManagementUserSiteAccess: async (siteGuid: string, marketViewUserGuid: string, disableUserIfNoOtherSites?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteGuid' is not null or undefined
            assertParamExists('deleteCommodityManagementUserSiteAccess', 'siteGuid', siteGuid)
            // verify required parameter 'marketViewUserGuid' is not null or undefined
            assertParamExists('deleteCommodityManagementUserSiteAccess', 'marketViewUserGuid', marketViewUserGuid)
            const localVarPath = `/market-view/commodity-management/sites/{siteGuid}/{marketViewUserGuid}`
                .replace(`{${"siteGuid"}}`, encodeURIComponent(String(siteGuid)))
                .replace(`{${"marketViewUserGuid"}}`, encodeURIComponent(String(marketViewUserGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (disableUserIfNoOtherSites !== undefined) {
                localVarQueryParameter['DisableUserIfNoOtherSites'] = disableUserIfNoOtherSites;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailScheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailSchedule: async (emailScheduleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailScheduleId' is not null or undefined
            assertParamExists('deleteEmailSchedule', 'emailScheduleId', emailScheduleId)
            const localVarPath = `/market-view/email-schedules/{emailScheduleId}`
                .replace(`{${"emailScheduleId"}}`, encodeURIComponent(String(emailScheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarketViewSavedQuery: async (savedQueryId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'savedQueryId' is not null or undefined
            assertParamExists('deleteMarketViewSavedQuery', 'savedQueryId', savedQueryId)
            const localVarPath = `/market-view/saved-queries/{savedQueryId}`
                .replace(`{${"savedQueryId"}}`, encodeURIComponent(String(savedQueryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarketViewUserFavoritedProduct: async (productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('deleteMarketViewUserFavoritedProduct', 'productId', productId)
            const localVarPath = `/market-view/products/{productId}/favorites`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMarketViewSavedQuery: async (savedQueryId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'savedQueryId' is not null or undefined
            assertParamExists('exportMarketViewSavedQuery', 'savedQueryId', savedQueryId)
            const localVarPath = `/market-view/saved-queries/{savedQueryId}/export`
                .replace(`{${"savedQueryId"}}`, encodeURIComponent(String(savedQueryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: async (companyGuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyGuid' is not null or undefined
            assertParamExists('getCompany', 'companyGuid', companyGuid)
            const localVarPath = `/market-view/companies/{companyGuid}`
                .replace(`{${"companyGuid"}}`, encodeURIComponent(String(companyGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveBasisPrices: async (startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getDecisiveBasisPrices', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getDecisiveBasisPrices', 'endDate', endDate)
            // verify required parameter 'commodity' is not null or undefined
            assertParamExists('getDecisiveBasisPrices', 'commodity', commodity)
            const localVarPath = `/market-view/decisive/mfmbasisprices/{startDate}/{endDate}/{commodity}`
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)))
                .replace(`{${"endDate"}}`, encodeURIComponent(String(endDate)))
                .replace(`{${"commodity"}}`, encodeURIComponent(String(commodity)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (markToMarketDate !== undefined) {
                localVarQueryParameter['MarkToMarketDate'] = (markToMarketDate as any instanceof Date) ?
                    (markToMarketDate as any).toISOString() :
                    markToMarketDate;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveFutureBasisPricesRangeByCommodity: async (startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getDecisiveFutureBasisPricesRangeByCommodity', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getDecisiveFutureBasisPricesRangeByCommodity', 'endDate', endDate)
            // verify required parameter 'commodity' is not null or undefined
            assertParamExists('getDecisiveFutureBasisPricesRangeByCommodity', 'commodity', commodity)
            const localVarPath = `/market-view/decisive/mfmfuturesbasisprices/{startDate}/{endDate}/{commodity}`
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)))
                .replace(`{${"endDate"}}`, encodeURIComponent(String(endDate)))
                .replace(`{${"commodity"}}`, encodeURIComponent(String(commodity)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (markToMarketDate !== undefined) {
                localVarQueryParameter['MarkToMarketDate'] = (markToMarketDate as any instanceof Date) ?
                    (markToMarketDate as any).toISOString() :
                    markToMarketDate;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveFuturePricesRangeByCommodity: async (startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getDecisiveFuturePricesRangeByCommodity', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getDecisiveFuturePricesRangeByCommodity', 'endDate', endDate)
            // verify required parameter 'commodity' is not null or undefined
            assertParamExists('getDecisiveFuturePricesRangeByCommodity', 'commodity', commodity)
            const localVarPath = `/market-view/decisive/mfmfuturesprices/{startDate}/{endDate}/{commodity}`
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)))
                .replace(`{${"endDate"}}`, encodeURIComponent(String(endDate)))
                .replace(`{${"commodity"}}`, encodeURIComponent(String(commodity)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (markToMarketDate !== undefined) {
                localVarQueryParameter['MarkToMarketDate'] = (markToMarketDate as any instanceof Date) ?
                    (markToMarketDate as any).toISOString() :
                    markToMarketDate;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveSpecialtyCropPricesRangeByCommodity: async (startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getDecisiveSpecialtyCropPricesRangeByCommodity', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getDecisiveSpecialtyCropPricesRangeByCommodity', 'endDate', endDate)
            // verify required parameter 'commodity' is not null or undefined
            assertParamExists('getDecisiveSpecialtyCropPricesRangeByCommodity', 'commodity', commodity)
            const localVarPath = `/market-view/decisive/mfmspecialtycrops/{startDate}/{endDate}/{commodity}`
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)))
                .replace(`{${"endDate"}}`, encodeURIComponent(String(endDate)))
                .replace(`{${"commodity"}}`, encodeURIComponent(String(commodity)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (markToMarketDate !== undefined) {
                localVarQueryParameter['MarkToMarketDate'] = (markToMarketDate as any instanceof Date) ?
                    (markToMarketDate as any).toISOString() :
                    markToMarketDate;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [forecastHistoryYears] 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastInternal: async (productId: string, forecastHistoryYears?: number, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getForecastInternal', 'productId', productId)
            const localVarPath = `/market-view/internal/forecast/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (forecastHistoryYears !== undefined) {
                localVarQueryParameter['ForecastHistoryYears'] = forecastHistoryYears;
            }

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (recentHistoryDays !== undefined) {
                localVarQueryParameter['RecentHistoryDays'] = recentHistoryDays;
            }

            if (historicalMedianYears !== undefined) {
                localVarQueryParameter['HistoricalMedianYears'] = historicalMedianYears;
            }

            if (startContractDateYear !== undefined) {
                localVarQueryParameter['StartContractDate.Year'] = startContractDateYear;
            }

            if (startContractDateMonth !== undefined) {
                localVarQueryParameter['StartContractDate.Month'] = startContractDateMonth;
            }

            if (startContractDateLabel !== undefined) {
                localVarQueryParameter['StartContractDate.Label'] = startContractDateLabel;
            }

            if (monthsAhead !== undefined) {
                localVarQueryParameter['MonthsAhead'] = monthsAhead;
            }

            if (applyPpi !== undefined) {
                localVarQueryParameter['ApplyPpi'] = applyPpi;
            }

            if (refreshCache !== undefined) {
                localVarQueryParameter['RefreshCache'] = refreshCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [forecastHistoryYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastWithHistory: async (productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getForecastWithHistory', 'productId', productId)
            const localVarPath = `/market-view/webtools/forecast/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (recentHistoryDays !== undefined) {
                localVarQueryParameter['RecentHistoryDays'] = recentHistoryDays;
            }

            if (historicalMedianYears !== undefined) {
                localVarQueryParameter['HistoricalMedianYears'] = historicalMedianYears;
            }

            if (forecastHistoryYears !== undefined) {
                localVarQueryParameter['ForecastHistoryYears'] = forecastHistoryYears;
            }

            if (startContractDateYear !== undefined) {
                localVarQueryParameter['StartContractDate.Year'] = startContractDateYear;
            }

            if (startContractDateMonth !== undefined) {
                localVarQueryParameter['StartContractDate.Month'] = startContractDateMonth;
            }

            if (startContractDateLabel !== undefined) {
                localVarQueryParameter['StartContractDate.Label'] = startContractDateLabel;
            }

            if (monthsAhead !== undefined) {
                localVarQueryParameter['MonthsAhead'] = monthsAhead;
            }

            if (applyPpi !== undefined) {
                localVarQueryParameter['ApplyPpi'] = applyPpi;
            }

            if (refreshCache !== undefined) {
                localVarQueryParameter['RefreshCache'] = refreshCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [forecastHistoryYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastWithHistoryInternal: async (productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getForecastWithHistoryInternal', 'productId', productId)
            const localVarPath = `/market-view/internal/forecast/{productId}/history`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (recentHistoryDays !== undefined) {
                localVarQueryParameter['RecentHistoryDays'] = recentHistoryDays;
            }

            if (historicalMedianYears !== undefined) {
                localVarQueryParameter['HistoricalMedianYears'] = historicalMedianYears;
            }

            if (forecastHistoryYears !== undefined) {
                localVarQueryParameter['ForecastHistoryYears'] = forecastHistoryYears;
            }

            if (startContractDateYear !== undefined) {
                localVarQueryParameter['StartContractDate.Year'] = startContractDateYear;
            }

            if (startContractDateMonth !== undefined) {
                localVarQueryParameter['StartContractDate.Month'] = startContractDateMonth;
            }

            if (startContractDateLabel !== undefined) {
                localVarQueryParameter['StartContractDate.Label'] = startContractDateLabel;
            }

            if (monthsAhead !== undefined) {
                localVarQueryParameter['MonthsAhead'] = monthsAhead;
            }

            if (applyPpi !== undefined) {
                localVarQueryParameter['ApplyPpi'] = applyPpi;
            }

            if (refreshCache !== undefined) {
                localVarQueryParameter['RefreshCache'] = refreshCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketViewLastQuoteDate: async (symbolId: string, asOfDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbolId' is not null or undefined
            assertParamExists('getMarketViewLastQuoteDate', 'symbolId', symbolId)
            const localVarPath = `/market-view/prices/{symbolId}/last-quote-dates`
                .replace(`{${"symbolId"}}`, encodeURIComponent(String(symbolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (asOfDate !== undefined) {
                localVarQueryParameter['AsOfDate'] = (asOfDate as any instanceof Date) ?
                    (asOfDate as any).toISOString() :
                    asOfDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketViewLastQuoteDateApi: async (symbolId: string, asOfDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbolId' is not null or undefined
            assertParamExists('getMarketViewLastQuoteDateApi', 'symbolId', symbolId)
            const localVarPath = `/market-view/api/prices/{symbolId}/last-quote-dates`
                .replace(`{${"symbolId"}}`, encodeURIComponent(String(symbolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (asOfDate !== undefined) {
                localVarQueryParameter['AsOfDate'] = (asOfDate as any instanceof Date) ?
                    (asOfDate as any).toISOString() :
                    asOfDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {string} [stoneXUserGuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketViewUser: async (marketViewUserGuid: string, stoneXUserGuid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketViewUserGuid' is not null or undefined
            assertParamExists('getMarketViewUser', 'marketViewUserGuid', marketViewUserGuid)
            const localVarPath = `/market-view/users/{marketViewUserGuid}`
                .replace(`{${"marketViewUserGuid"}}`, encodeURIComponent(String(marketViewUserGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (stoneXUserGuid !== undefined) {
                localVarQueryParameter['StoneXUserGuid'] = stoneXUserGuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommodityManagementSiteUsers: async (siteGuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteGuid' is not null or undefined
            assertParamExists('listCommodityManagementSiteUsers', 'siteGuid', siteGuid)
            const localVarPath = `/market-view/commodity-management/sites/{siteGuid}/users`
                .replace(`{${"siteGuid"}}`, encodeURIComponent(String(siteGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [includeUserSiteAccess] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommodityManagementSites: async (includeUserSiteAccess?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/commodity-management/sites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeUserSiteAccess !== undefined) {
                localVarQueryParameter['IncludeUserSiteAccess'] = includeUserSiteAccess;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanies: async (sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailScheduleSource} [source] 
         * @param {number} [sourceId] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmailSchedules: async (source?: EmailScheduleSource, sourceId?: number, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/email-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (source !== undefined) {
                localVarQueryParameter['Source'] = source;
            }

            if (sourceId !== undefined) {
                localVarQueryParameter['SourceId'] = sourceId;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ListMarketViewContractPricesRequest} [listMarketViewContractPricesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewContractPricesApi: async (listMarketViewContractPricesRequest?: ListMarketViewContractPricesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/api/prices/contract-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listMarketViewContractPricesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {Array<Currency>} currencies 
         * @param {Array<ContractDate>} contractMonths 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewCurrencySpotRates: async (quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('listMarketViewCurrencySpotRates', 'quoteDate', quoteDate)
            // verify required parameter 'currencies' is not null or undefined
            assertParamExists('listMarketViewCurrencySpotRates', 'currencies', currencies)
            // verify required parameter 'contractMonths' is not null or undefined
            assertParamExists('listMarketViewCurrencySpotRates', 'contractMonths', contractMonths)
            const localVarPath = `/market-view/prices/spot-rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (currencies) {
                localVarQueryParameter['Currencies'] = currencies;
            }

            if (contractMonths) {
                localVarQueryParameter['ContractMonths'] = contractMonths;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {Array<Currency>} currencies 
         * @param {Array<ContractDate>} contractMonths 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewCurrencySpotRatesApi: async (quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('listMarketViewCurrencySpotRatesApi', 'quoteDate', quoteDate)
            // verify required parameter 'currencies' is not null or undefined
            assertParamExists('listMarketViewCurrencySpotRatesApi', 'currencies', currencies)
            // verify required parameter 'contractMonths' is not null or undefined
            assertParamExists('listMarketViewCurrencySpotRatesApi', 'contractMonths', contractMonths)
            const localVarPath = `/market-view/api/prices/spot-rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (currencies) {
                localVarQueryParameter['Currencies'] = currencies;
            }

            if (contractMonths) {
                localVarQueryParameter['ContractMonths'] = contractMonths;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewDailyPrices: async (productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewDailyPrices', 'productId', productId)
            const localVarPath = `/market-view/prices/{productId}/daily`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} productIds 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewExpirationDates: async (productIds: Array<number>, refreshCache?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productIds' is not null or undefined
            assertParamExists('listMarketViewExpirationDates', 'productIds', productIds)
            const localVarPath = `/market-view/expiration-dates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productIds) {
                localVarQueryParameter['ProductIds'] = productIds;
            }

            if (refreshCache !== undefined) {
                localVarQueryParameter['RefreshCache'] = refreshCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} productIds 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewExpirationDatesApi: async (productIds: Array<number>, refreshCache?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productIds' is not null or undefined
            assertParamExists('listMarketViewExpirationDatesApi', 'productIds', productIds)
            const localVarPath = `/market-view/api/expiration-dates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productIds) {
                localVarQueryParameter['ProductIds'] = productIds;
            }

            if (refreshCache !== undefined) {
                localVarQueryParameter['RefreshCache'] = refreshCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} quoteDate 
         * @param {number} [numberOfMonths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewForwardCurveQuery: async (productId: string, quoteDate: string, numberOfMonths?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewForwardCurveQuery', 'productId', productId)
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('listMarketViewForwardCurveQuery', 'quoteDate', quoteDate)
            const localVarPath = `/market-view/prices/{productId}/forward-curve`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (numberOfMonths !== undefined) {
                localVarQueryParameter['NumberOfMonths'] = numberOfMonths;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} quoteDate 
         * @param {number} [numberOfMonths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewForwardCurveQueryApi: async (productId: string, quoteDate: string, numberOfMonths?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewForwardCurveQueryApi', 'productId', productId)
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('listMarketViewForwardCurveQueryApi', 'quoteDate', quoteDate)
            const localVarPath = `/market-view/api/prices/{productId}/forward-curve`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (numberOfMonths !== undefined) {
                localVarQueryParameter['NumberOfMonths'] = numberOfMonths;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} symbolIds 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewLastQuoteDate: async (symbolIds: Array<number>, asOfDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbolIds' is not null or undefined
            assertParamExists('listMarketViewLastQuoteDate', 'symbolIds', symbolIds)
            const localVarPath = `/market-view/prices/last-quote-dates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (symbolIds) {
                localVarQueryParameter['SymbolIds'] = symbolIds;
            }

            if (asOfDate !== undefined) {
                localVarQueryParameter['AsOfDate'] = (asOfDate as any instanceof Date) ?
                    (asOfDate as any).toISOString() :
                    asOfDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} symbolIds 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewLastQuoteDateApi: async (symbolIds: Array<number>, asOfDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbolIds' is not null or undefined
            assertParamExists('listMarketViewLastQuoteDateApi', 'symbolIds', symbolIds)
            const localVarPath = `/market-view/api/prices/last-quote-dates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (symbolIds) {
                localVarQueryParameter['SymbolIds'] = symbolIds;
            }

            if (asOfDate !== undefined) {
                localVarQueryParameter['AsOfDate'] = (asOfDate as any instanceof Date) ?
                    (asOfDate as any).toISOString() :
                    asOfDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryCalendarStripAvearge: async (productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPriceQueryCalendarStripAvearge', 'productId', productId)
            // verify required parameter 'years' is not null or undefined
            assertParamExists('listMarketViewPriceQueryCalendarStripAvearge', 'years', years)
            const localVarPath = `/market-view/prices/{productId}/calendar-strip-average`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (years) {
                localVarQueryParameter['Years'] = years;
            }

            if (userVolumeId !== undefined) {
                localVarQueryParameter['UserVolumeId'] = userVolumeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryCalendarStripAverageApi: async (productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPriceQueryCalendarStripAverageApi', 'productId', productId)
            // verify required parameter 'years' is not null or undefined
            assertParamExists('listMarketViewPriceQueryCalendarStripAverageApi', 'years', years)
            const localVarPath = `/market-view/api/prices/{productId}/calendar-strip-average`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (years) {
                localVarQueryParameter['Years'] = years;
            }

            if (userVolumeId !== undefined) {
                localVarQueryParameter['UserVolumeId'] = userVolumeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} monthsAhead 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryRollingMonthAhead: async (productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPriceQueryRollingMonthAhead', 'productId', productId)
            // verify required parameter 'monthsAhead' is not null or undefined
            assertParamExists('listMarketViewPriceQueryRollingMonthAhead', 'monthsAhead', monthsAhead)
            const localVarPath = `/market-view/prices/{productId}/rolling-month-ahead`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (monthsAhead !== undefined) {
                localVarQueryParameter['MonthsAhead'] = monthsAhead;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} monthsAhead 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryRollingMonthAheadApi: async (productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPriceQueryRollingMonthAheadApi', 'productId', productId)
            // verify required parameter 'monthsAhead' is not null or undefined
            assertParamExists('listMarketViewPriceQueryRollingMonthAheadApi', 'monthsAhead', monthsAhead)
            const localVarPath = `/market-view/api/prices/{productId}/rolling-month-ahead`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (monthsAhead !== undefined) {
                localVarQueryParameter['MonthsAhead'] = monthsAhead;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPrices: async (productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPrices', 'productId', productId)
            // verify required parameter 'years' is not null or undefined
            assertParamExists('listMarketViewPrices', 'years', years)
            // verify required parameter 'months' is not null or undefined
            assertParamExists('listMarketViewPrices', 'months', months)
            const localVarPath = `/market-view/prices/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (years) {
                localVarQueryParameter['Years'] = years;
            }

            if (months) {
                localVarQueryParameter['Months'] = months;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesApi: async (productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPricesApi', 'productId', productId)
            // verify required parameter 'years' is not null or undefined
            assertParamExists('listMarketViewPricesApi', 'years', years)
            // verify required parameter 'months' is not null or undefined
            assertParamExists('listMarketViewPricesApi', 'months', months)
            const localVarPath = `/market-view/api/prices/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (years) {
                localVarQueryParameter['Years'] = years;
            }

            if (months) {
                localVarQueryParameter['Months'] = months;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} contractYear 
         * @param {string} contractMonth 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesBySymbol: async (symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbolId' is not null or undefined
            assertParamExists('listMarketViewPricesBySymbol', 'symbolId', symbolId)
            // verify required parameter 'contractYear' is not null or undefined
            assertParamExists('listMarketViewPricesBySymbol', 'contractYear', contractYear)
            // verify required parameter 'contractMonth' is not null or undefined
            assertParamExists('listMarketViewPricesBySymbol', 'contractMonth', contractMonth)
            const localVarPath = `/market-view/prices/{symbolId}/{contractYear}/{contractMonth}`
                .replace(`{${"symbolId"}}`, encodeURIComponent(String(symbolId)))
                .replace(`{${"contractYear"}}`, encodeURIComponent(String(contractYear)))
                .replace(`{${"contractMonth"}}`, encodeURIComponent(String(contractMonth)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} contractYear 
         * @param {string} contractMonth 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesBySymbolApi: async (symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbolId' is not null or undefined
            assertParamExists('listMarketViewPricesBySymbolApi', 'symbolId', symbolId)
            // verify required parameter 'contractYear' is not null or undefined
            assertParamExists('listMarketViewPricesBySymbolApi', 'contractYear', contractYear)
            // verify required parameter 'contractMonth' is not null or undefined
            assertParamExists('listMarketViewPricesBySymbolApi', 'contractMonth', contractMonth)
            const localVarPath = `/market-view/api/prices/{symbolId}/{contractYear}/{contractMonth}`
                .replace(`{${"symbolId"}}`, encodeURIComponent(String(symbolId)))
                .replace(`{${"contractYear"}}`, encodeURIComponent(String(contractYear)))
                .replace(`{${"contractMonth"}}`, encodeURIComponent(String(contractMonth)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesInternal: async (productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPricesInternal', 'productId', productId)
            // verify required parameter 'years' is not null or undefined
            assertParamExists('listMarketViewPricesInternal', 'years', years)
            // verify required parameter 'months' is not null or undefined
            assertParamExists('listMarketViewPricesInternal', 'months', months)
            const localVarPath = `/market-view/internal/prices/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (years) {
                localVarQueryParameter['Years'] = years;
            }

            if (months) {
                localVarQueryParameter['Months'] = months;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [contractDateRangeStartYear] 
         * @param {number} [contractDateRangeStartMonth] 
         * @param {number} [contractDateRangeEndYear] 
         * @param {number} [contractDateRangeEndMonth] 
         * @param {number} [contractDateRangeStartContractDateYear] 
         * @param {number} [contractDateRangeStartContractDateMonth] 
         * @param {string} [contractDateRangeStartContractDateLabel] 
         * @param {number} [contractDateRangeEndContractDateYear] 
         * @param {number} [contractDateRangeEndContractDateMonth] 
         * @param {string} [contractDateRangeEndContractDateLabel] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesStripAverage: async (productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPricesStripAverage', 'productId', productId)
            const localVarPath = `/market-view/prices/{productId}/strip-average`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (contractDateRangeStartYear !== undefined) {
                localVarQueryParameter['ContractDateRange.StartYear'] = contractDateRangeStartYear;
            }

            if (contractDateRangeStartMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.StartMonth'] = contractDateRangeStartMonth;
            }

            if (contractDateRangeEndYear !== undefined) {
                localVarQueryParameter['ContractDateRange.EndYear'] = contractDateRangeEndYear;
            }

            if (contractDateRangeEndMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.EndMonth'] = contractDateRangeEndMonth;
            }

            if (contractDateRangeStartContractDateYear !== undefined) {
                localVarQueryParameter['ContractDateRange.StartContractDate.Year'] = contractDateRangeStartContractDateYear;
            }

            if (contractDateRangeStartContractDateMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.StartContractDate.Month'] = contractDateRangeStartContractDateMonth;
            }

            if (contractDateRangeStartContractDateLabel !== undefined) {
                localVarQueryParameter['ContractDateRange.StartContractDate.Label'] = contractDateRangeStartContractDateLabel;
            }

            if (contractDateRangeEndContractDateYear !== undefined) {
                localVarQueryParameter['ContractDateRange.EndContractDate.Year'] = contractDateRangeEndContractDateYear;
            }

            if (contractDateRangeEndContractDateMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.EndContractDate.Month'] = contractDateRangeEndContractDateMonth;
            }

            if (contractDateRangeEndContractDateLabel !== undefined) {
                localVarQueryParameter['ContractDateRange.EndContractDate.Label'] = contractDateRangeEndContractDateLabel;
            }

            if (userVolumeId !== undefined) {
                localVarQueryParameter['UserVolumeId'] = userVolumeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [contractDateRangeStartYear] 
         * @param {number} [contractDateRangeStartMonth] 
         * @param {number} [contractDateRangeEndYear] 
         * @param {number} [contractDateRangeEndMonth] 
         * @param {number} [contractDateRangeStartContractDateYear] 
         * @param {number} [contractDateRangeStartContractDateMonth] 
         * @param {string} [contractDateRangeStartContractDateLabel] 
         * @param {number} [contractDateRangeEndContractDateYear] 
         * @param {number} [contractDateRangeEndContractDateMonth] 
         * @param {string} [contractDateRangeEndContractDateLabel] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesStripAverageApi: async (productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPricesStripAverageApi', 'productId', productId)
            const localVarPath = `/market-view/api/prices/{productId}/strip-average`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (contractDateRangeStartYear !== undefined) {
                localVarQueryParameter['ContractDateRange.StartYear'] = contractDateRangeStartYear;
            }

            if (contractDateRangeStartMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.StartMonth'] = contractDateRangeStartMonth;
            }

            if (contractDateRangeEndYear !== undefined) {
                localVarQueryParameter['ContractDateRange.EndYear'] = contractDateRangeEndYear;
            }

            if (contractDateRangeEndMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.EndMonth'] = contractDateRangeEndMonth;
            }

            if (contractDateRangeStartContractDateYear !== undefined) {
                localVarQueryParameter['ContractDateRange.StartContractDate.Year'] = contractDateRangeStartContractDateYear;
            }

            if (contractDateRangeStartContractDateMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.StartContractDate.Month'] = contractDateRangeStartContractDateMonth;
            }

            if (contractDateRangeStartContractDateLabel !== undefined) {
                localVarQueryParameter['ContractDateRange.StartContractDate.Label'] = contractDateRangeStartContractDateLabel;
            }

            if (contractDateRangeEndContractDateYear !== undefined) {
                localVarQueryParameter['ContractDateRange.EndContractDate.Year'] = contractDateRangeEndContractDateYear;
            }

            if (contractDateRangeEndContractDateMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.EndContractDate.Month'] = contractDateRangeEndContractDateMonth;
            }

            if (contractDateRangeEndContractDateLabel !== undefined) {
                localVarQueryParameter['ContractDateRange.EndContractDate.Label'] = contractDateRangeEndContractDateLabel;
            }

            if (userVolumeId !== undefined) {
                localVarQueryParameter['UserVolumeId'] = userVolumeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewProductTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/products/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommodityType} [commodityType] 
         * @param {Array<number>} [productIds] 
         * @param {number} [minimumHistoryYears] 
         * @param {number} [lastQuoteDateThresholdDays] 
         * @param {boolean} [refreshCache] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewProducts: async (commodityType?: CommodityType, productIds?: Array<number>, minimumHistoryYears?: number, lastQuoteDateThresholdDays?: number, refreshCache?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (commodityType !== undefined) {
                localVarQueryParameter['CommodityType'] = commodityType;
            }

            if (productIds) {
                localVarQueryParameter['ProductIds'] = productIds;
            }

            if (minimumHistoryYears !== undefined) {
                localVarQueryParameter['MinimumHistoryYears'] = minimumHistoryYears;
            }

            if (lastQuoteDateThresholdDays !== undefined) {
                localVarQueryParameter['LastQuoteDateThresholdDays'] = lastQuoteDateThresholdDays;
            }

            if (refreshCache !== undefined) {
                localVarQueryParameter['RefreshCache'] = refreshCache;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommodityType} [commodityType] 
         * @param {PriceType} [priceType] 
         * @param {Array<number>} [productIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewProductsInternal: async (commodityType?: CommodityType, priceType?: PriceType, productIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/internal/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (commodityType !== undefined) {
                localVarQueryParameter['CommodityType'] = commodityType;
            }

            if (priceType !== undefined) {
                localVarQueryParameter['PriceType'] = priceType;
            }

            if (productIds) {
                localVarQueryParameter['ProductIds'] = productIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewSavedQuery: async (sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/saved-queries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewSettlementPrices: async (productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewSettlementPrices', 'productId', productId)
            const localVarPath = `/market-view/prices/{productId}/settlements`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewSettlementPricesApi: async (productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewSettlementPricesApi', 'productId', productId)
            const localVarPath = `/market-view/api/prices/{productId}/settlements`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [marketViewUserGuids] 
         * @param {string} [companyGuid] 
         * @param {boolean} [includeSites] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewUsers: async (marketViewUserGuids?: Array<string>, companyGuid?: string, includeSites?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (marketViewUserGuids) {
                localVarQueryParameter['MarketViewUserGuids'] = marketViewUserGuids;
            }

            if (companyGuid !== undefined) {
                localVarQueryParameter['CompanyGuid'] = companyGuid;
            }

            if (includeSites !== undefined) {
                localVarQueryParameter['IncludeSites'] = includeSites;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewVolumes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/volumes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketViewProductTradingMonths: async (productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('marketViewProductTradingMonths', 'productId', productId)
            const localVarPath = `/market-view/products/{productId}/trading-months`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketViewUserAuthorizationCallback: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/authorization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailScheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailScheduleNow: async (emailScheduleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailScheduleId' is not null or undefined
            assertParamExists('sendEmailScheduleNow', 'emailScheduleId', emailScheduleId)
            const localVarPath = `/market-view/email-schedules/{emailScheduleId}/send`
                .replace(`{${"emailScheduleId"}}`, encodeURIComponent(String(emailScheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {SendMarketViewSavedQueryEmailRequest} [sendMarketViewSavedQueryEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMarketViewSavedQueryEmail: async (savedQueryId: string, sendMarketViewSavedQueryEmailRequest?: SendMarketViewSavedQueryEmailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'savedQueryId' is not null or undefined
            assertParamExists('sendMarketViewSavedQueryEmail', 'savedQueryId', savedQueryId)
            const localVarPath = `/market-view/saved-queries/{savedQueryId}/email`
                .replace(`{${"savedQueryId"}}`, encodeURIComponent(String(savedQueryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendMarketViewSavedQueryEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} siteName 
         * @param {string} companyGuid 
         * @param {Array<UserAccessUpdateModel>} userSiteAccesses 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommodityManagementSite: async (siteGuid: string, siteName: string, companyGuid: string, userSiteAccesses: Array<UserAccessUpdateModel>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteGuid' is not null or undefined
            assertParamExists('updateCommodityManagementSite', 'siteGuid', siteGuid)
            // verify required parameter 'siteName' is not null or undefined
            assertParamExists('updateCommodityManagementSite', 'siteName', siteName)
            // verify required parameter 'companyGuid' is not null or undefined
            assertParamExists('updateCommodityManagementSite', 'companyGuid', companyGuid)
            // verify required parameter 'userSiteAccesses' is not null or undefined
            assertParamExists('updateCommodityManagementSite', 'userSiteAccesses', userSiteAccesses)
            const localVarPath = `/market-view/commodity-management/sites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (siteGuid !== undefined) {
                localVarQueryParameter['SiteGuid'] = siteGuid;
            }

            if (siteName !== undefined) {
                localVarQueryParameter['SiteName'] = siteName;
            }

            if (companyGuid !== undefined) {
                localVarQueryParameter['CompanyGuid'] = companyGuid;
            }

            if (userSiteAccesses) {
                localVarQueryParameter['UserSiteAccesses'] = userSiteAccesses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {boolean} [isSiteManager] 
         * @param {Array<CommodityManagementUserPermissions>} [permissions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommodityManagementUserSiteAccess: async (siteGuid: string, marketViewUserGuid: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteGuid' is not null or undefined
            assertParamExists('updateCommodityManagementUserSiteAccess', 'siteGuid', siteGuid)
            // verify required parameter 'marketViewUserGuid' is not null or undefined
            assertParamExists('updateCommodityManagementUserSiteAccess', 'marketViewUserGuid', marketViewUserGuid)
            const localVarPath = `/market-view/commodity-management/sites/{siteGuid}/{marketViewUserGuid}`
                .replace(`{${"siteGuid"}}`, encodeURIComponent(String(siteGuid)))
                .replace(`{${"marketViewUserGuid"}}`, encodeURIComponent(String(marketViewUserGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isSiteManager !== undefined) {
                localVarQueryParameter['IsSiteManager'] = isSiteManager;
            }

            if (permissions) {
                localVarQueryParameter['Permissions'] = permissions;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {UpdateCompanyRequest} [updateCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany: async (companyGuid: string, updateCompanyRequest?: UpdateCompanyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyGuid' is not null or undefined
            assertParamExists('updateCompany', 'companyGuid', companyGuid)
            const localVarPath = `/market-view/companies/{companyGuid}`
                .replace(`{${"companyGuid"}}`, encodeURIComponent(String(companyGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompanyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {boolean} isEnabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyEnabled: async (companyGuid: string, isEnabled: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyGuid' is not null or undefined
            assertParamExists('updateCompanyEnabled', 'companyGuid', companyGuid)
            // verify required parameter 'isEnabled' is not null or undefined
            assertParamExists('updateCompanyEnabled', 'isEnabled', isEnabled)
            const localVarPath = `/market-view/companies/{companyGuid}/enabled`
                .replace(`{${"companyGuid"}}`, encodeURIComponent(String(companyGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isEnabled !== undefined) {
                localVarQueryParameter['IsEnabled'] = isEnabled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {UpdateMarketViewUserRequest} [updateMarketViewUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketViewUser: async (marketViewUserGuid: string, updateMarketViewUserRequest?: UpdateMarketViewUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketViewUserGuid' is not null or undefined
            assertParamExists('updateMarketViewUser', 'marketViewUserGuid', marketViewUserGuid)
            const localVarPath = `/market-view/users/{marketViewUserGuid}`
                .replace(`{${"marketViewUserGuid"}}`, encodeURIComponent(String(marketViewUserGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMarketViewUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {boolean} isEnabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketViewUserEnabled: async (marketViewUserGuid: string, isEnabled: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketViewUserGuid' is not null or undefined
            assertParamExists('updateMarketViewUserEnabled', 'marketViewUserGuid', marketViewUserGuid)
            // verify required parameter 'isEnabled' is not null or undefined
            assertParamExists('updateMarketViewUserEnabled', 'isEnabled', isEnabled)
            const localVarPath = `/market-view/users/{marketViewUserGuid}/enabled`
                .replace(`{${"marketViewUserGuid"}}`, encodeURIComponent(String(marketViewUserGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isEnabled !== undefined) {
                localVarQueryParameter['IsEnabled'] = isEnabled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertEmailScheduleRequest} [upsertEmailScheduleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertEmailSchedule: async (upsertEmailScheduleRequest?: UpsertEmailScheduleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/email-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertEmailScheduleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketViewApi - functional programming interface
 * @export
 */
export const MarketViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} siteName 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCommodityManagementSite(siteName: string, companyGuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCommodityManagementSiteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCommodityManagementSite(siteName, companyGuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {string} [email] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {boolean} [isSiteManager] 
         * @param {Array<CommodityManagementUserPermissions>} [permissions] 
         * @param {boolean} [initializeAccessIfNew] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCommodityManagementUserSiteAccess(siteGuid: string, marketViewUserGuid: string, email?: string, firstName?: string, lastName?: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, initializeAccessIfNew?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, email, firstName, lastName, isSiteManager, permissions, initializeAccessIfNew, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddCompanyRequest} [addCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCompany(addCompanyRequest?: AddCompanyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCompany(addCompanyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} savedQueryId 
         * @param {string} name 
         * @param {Array<MarkItViewQuerySavedParameters>} markItViewQuerySavedParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMarketViewSavedQuery(savedQueryId: number, name: string, markItViewQuerySavedParameters: Array<MarkItViewQuerySavedParameters>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddMarketViewSavedQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMarketViewSavedQuery(savedQueryId, name, markItViewQuerySavedParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddMarketViewUserRequest} [addMarketViewUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMarketViewUser(addMarketViewUserRequest?: AddMarketViewUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddMarketViewUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMarketViewUser(addMarketViewUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {AddMarketViewUserFavoritedProductRequest} [addMarketViewUserFavoritedProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMarketViewUserFavoritedProduct(productId: string, addMarketViewUserFavoritedProductRequest?: AddMarketViewUserFavoritedProductRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMarketViewUserFavoritedProduct(productId, addMarketViewUserFavoritedProductRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} userVolumeId 
         * @param {string} name 
         * @param {{ [key: string]: number; }} volumes 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMarketViewVolume(userVolumeId: number, name: string, volumes: { [key: string]: number; }, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddMarketViewVolumeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMarketViewVolume(userVolumeId, name, volumes, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AgreeToMarketViewTermsAndConditionsRequest} [agreeToMarketViewTermsAndConditionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agreeToDemeterTermsAndConditions(agreeToMarketViewTermsAndConditionsRequest?: AgreeToMarketViewTermsAndConditionsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agreeToDemeterTermsAndConditions(agreeToMarketViewTermsAndConditionsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CalculateMatrixRequest} [calculateMatrixRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateMatrix(calculateMatrixRequest?: CalculateMatrixRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculateMatrixResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateMatrix(calculateMatrixRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {boolean} [disableUserIfNoOtherSites] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCommodityManagementUserSiteAccess(siteGuid: string, marketViewUserGuid: string, disableUserIfNoOtherSites?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, disableUserIfNoOtherSites, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} emailScheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmailSchedule(emailScheduleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmailSchedule(emailScheduleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMarketViewSavedQuery(savedQueryId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMarketViewSavedQuery(savedQueryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMarketViewUserFavoritedProduct(productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMarketViewUserFavoritedProduct(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportMarketViewSavedQuery(savedQueryId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportMarketViewSavedQuery(savedQueryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompany(companyGuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompany(companyGuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDecisiveBasisPrices(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DecisiveMarketPriceModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDecisiveBasisPrices(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDecisiveFutureBasisPricesRangeByCommodity(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DecisiveMarketPriceModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDecisiveFutureBasisPricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDecisiveFuturePricesRangeByCommodity(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DecisiveMarketPriceModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDecisiveFuturePricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDecisiveSpecialtyCropPricesRangeByCommodity(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DecisiveMarketPriceModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDecisiveSpecialtyCropPricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [forecastHistoryYears] 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForecastInternal(productId: string, forecastHistoryYears?: number, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetForecastResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForecastInternal(productId, forecastHistoryYears, quoteDate, recentHistoryDays, historicalMedianYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [forecastHistoryYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForecastWithHistory(productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetForecastWithHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForecastWithHistory(productId, quoteDate, recentHistoryDays, historicalMedianYears, forecastHistoryYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [forecastHistoryYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForecastWithHistoryInternal(productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetForecastWithHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForecastWithHistoryInternal(productId, quoteDate, recentHistoryDays, historicalMedianYears, forecastHistoryYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketViewLastQuoteDate(symbolId: string, asOfDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMarketViewLastQuoteDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketViewLastQuoteDate(symbolId, asOfDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketViewLastQuoteDateApi(symbolId: string, asOfDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMarketViewLastQuoteDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketViewLastQuoteDateApi(symbolId, asOfDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {string} [stoneXUserGuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketViewUser(marketViewUserGuid: string, stoneXUserGuid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMarketViewUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketViewUser(marketViewUserGuid, stoneXUserGuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCommodityManagementSiteUsers(siteGuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCommodityManagementSiteUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCommodityManagementSiteUsers(siteGuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} [includeUserSiteAccess] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCommodityManagementSites(includeUserSiteAccess?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCommodityManagementSitesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCommodityManagementSites(includeUserSiteAccess, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCompanies(sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCompaniesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCompanies(sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EmailScheduleSource} [source] 
         * @param {number} [sourceId] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEmailSchedules(source?: EmailScheduleSource, sourceId?: number, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListEmailSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEmailSchedules(source, sourceId, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ListMarketViewContractPricesRequest} [listMarketViewContractPricesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewContractPricesApi(listMarketViewContractPricesRequest?: ListMarketViewContractPricesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewContractPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewContractPricesApi(listMarketViewContractPricesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {Array<Currency>} currencies 
         * @param {Array<ContractDate>} contractMonths 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewCurrencySpotRates(quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewCurrencySpotRatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewCurrencySpotRates(quoteDate, currencies, contractMonths, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {Array<Currency>} currencies 
         * @param {Array<ContractDate>} contractMonths 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewCurrencySpotRatesApi(quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewCurrencySpotRatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewCurrencySpotRatesApi(quoteDate, currencies, contractMonths, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewDailyPrices(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryDailyPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewDailyPrices(productId, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} productIds 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewExpirationDates(productIds: Array<number>, refreshCache?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewExpirationDatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewExpirationDates(productIds, refreshCache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} productIds 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewExpirationDatesApi(productIds: Array<number>, refreshCache?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewExpirationDatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewExpirationDatesApi(productIds, refreshCache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} quoteDate 
         * @param {number} [numberOfMonths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewForwardCurveQuery(productId: string, quoteDate: string, numberOfMonths?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryForwardCurveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewForwardCurveQuery(productId, quoteDate, numberOfMonths, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} quoteDate 
         * @param {number} [numberOfMonths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewForwardCurveQueryApi(productId: string, quoteDate: string, numberOfMonths?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryForwardCurveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewForwardCurveQueryApi(productId, quoteDate, numberOfMonths, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} symbolIds 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewLastQuoteDate(symbolIds: Array<number>, asOfDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewLastQuoteDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewLastQuoteDate(symbolIds, asOfDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} symbolIds 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewLastQuoteDateApi(symbolIds: Array<number>, asOfDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewLastQuoteDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewLastQuoteDateApi(symbolIds, asOfDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPriceQueryCalendarStripAvearge(productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryCalendarStripAverageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPriceQueryCalendarStripAvearge(productId, years, quoteDateRangeStart, quoteDateRangeEnd, userVolumeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPriceQueryCalendarStripAverageApi(productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryCalendarStripAverageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPriceQueryCalendarStripAverageApi(productId, years, quoteDateRangeStart, quoteDateRangeEnd, userVolumeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} monthsAhead 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPriceQueryRollingMonthAhead(productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryRollingMonthAheadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPriceQueryRollingMonthAhead(productId, monthsAhead, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} monthsAhead 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPriceQueryRollingMonthAheadApi(productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryRollingMonthAheadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPriceQueryRollingMonthAheadApi(productId, monthsAhead, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPrices(productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPrices(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPricesApi(productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPricesApi(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} contractYear 
         * @param {string} contractMonth 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPricesBySymbol(symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPricesBySymbol(symbolId, contractYear, contractMonth, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} contractYear 
         * @param {string} contractMonth 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPricesBySymbolApi(symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPricesBySymbolApi(symbolId, contractYear, contractMonth, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPricesInternal(productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPricesInternal(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [contractDateRangeStartYear] 
         * @param {number} [contractDateRangeStartMonth] 
         * @param {number} [contractDateRangeEndYear] 
         * @param {number} [contractDateRangeEndMonth] 
         * @param {number} [contractDateRangeStartContractDateYear] 
         * @param {number} [contractDateRangeStartContractDateMonth] 
         * @param {string} [contractDateRangeStartContractDateLabel] 
         * @param {number} [contractDateRangeEndContractDateYear] 
         * @param {number} [contractDateRangeEndContractDateMonth] 
         * @param {string} [contractDateRangeEndContractDateLabel] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPricesStripAverage(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryStripAverageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPricesStripAverage(productId, quoteDateRangeStart, quoteDateRangeEnd, contractDateRangeStartYear, contractDateRangeStartMonth, contractDateRangeEndYear, contractDateRangeEndMonth, contractDateRangeStartContractDateYear, contractDateRangeStartContractDateMonth, contractDateRangeStartContractDateLabel, contractDateRangeEndContractDateYear, contractDateRangeEndContractDateMonth, contractDateRangeEndContractDateLabel, userVolumeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [contractDateRangeStartYear] 
         * @param {number} [contractDateRangeStartMonth] 
         * @param {number} [contractDateRangeEndYear] 
         * @param {number} [contractDateRangeEndMonth] 
         * @param {number} [contractDateRangeStartContractDateYear] 
         * @param {number} [contractDateRangeStartContractDateMonth] 
         * @param {string} [contractDateRangeStartContractDateLabel] 
         * @param {number} [contractDateRangeEndContractDateYear] 
         * @param {number} [contractDateRangeEndContractDateMonth] 
         * @param {string} [contractDateRangeEndContractDateLabel] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPricesStripAverageApi(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryStripAverageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPricesStripAverageApi(productId, quoteDateRangeStart, quoteDateRangeEnd, contractDateRangeStartYear, contractDateRangeStartMonth, contractDateRangeEndYear, contractDateRangeEndMonth, contractDateRangeStartContractDateYear, contractDateRangeStartContractDateMonth, contractDateRangeStartContractDateLabel, contractDateRangeEndContractDateYear, contractDateRangeEndContractDateMonth, contractDateRangeEndContractDateLabel, userVolumeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewProductTypes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewProductTypesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewProductTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CommodityType} [commodityType] 
         * @param {Array<number>} [productIds] 
         * @param {number} [minimumHistoryYears] 
         * @param {number} [lastQuoteDateThresholdDays] 
         * @param {boolean} [refreshCache] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewProducts(commodityType?: CommodityType, productIds?: Array<number>, minimumHistoryYears?: number, lastQuoteDateThresholdDays?: number, refreshCache?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewProducts(commodityType, productIds, minimumHistoryYears, lastQuoteDateThresholdDays, refreshCache, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CommodityType} [commodityType] 
         * @param {PriceType} [priceType] 
         * @param {Array<number>} [productIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewProductsInternal(commodityType?: CommodityType, priceType?: PriceType, productIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewInternalProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewProductsInternal(commodityType, priceType, productIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewSavedQuery(sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewSavedQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewSavedQuery(sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewSettlementPrices(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQuerySettlementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewSettlementPrices(productId, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewSettlementPricesApi(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQuerySettlementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewSettlementPricesApi(productId, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [marketViewUserGuids] 
         * @param {string} [companyGuid] 
         * @param {boolean} [includeSites] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewUsers(marketViewUserGuids?: Array<string>, companyGuid?: string, includeSites?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewUsers(marketViewUserGuids, companyGuid, includeSites, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewVolumes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewVolumesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewVolumes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketViewProductTradingMonths(productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewProductTradingMonthsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketViewProductTradingMonths(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketViewUserAuthorizationCallback(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMarketViewUserAuthorizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketViewUserAuthorizationCallback(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} emailScheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailScheduleNow(emailScheduleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendEmailScheduleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailScheduleNow(emailScheduleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {SendMarketViewSavedQueryEmailRequest} [sendMarketViewSavedQueryEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMarketViewSavedQueryEmail(savedQueryId: string, sendMarketViewSavedQueryEmailRequest?: SendMarketViewSavedQueryEmailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendMarketViewSavedQueryEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMarketViewSavedQueryEmail(savedQueryId, sendMarketViewSavedQueryEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} siteName 
         * @param {string} companyGuid 
         * @param {Array<UserAccessUpdateModel>} userSiteAccesses 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommodityManagementSite(siteGuid: string, siteName: string, companyGuid: string, userSiteAccesses: Array<UserAccessUpdateModel>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCommodityManagementSiteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommodityManagementSite(siteGuid, siteName, companyGuid, userSiteAccesses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {boolean} [isSiteManager] 
         * @param {Array<CommodityManagementUserPermissions>} [permissions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommodityManagementUserSiteAccess(siteGuid: string, marketViewUserGuid: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, isSiteManager, permissions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {UpdateCompanyRequest} [updateCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompany(companyGuid: string, updateCompanyRequest?: UpdateCompanyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompany(companyGuid, updateCompanyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {boolean} isEnabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompanyEnabled(companyGuid: string, isEnabled: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompanyEnabled(companyGuid, isEnabled, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {UpdateMarketViewUserRequest} [updateMarketViewUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMarketViewUser(marketViewUserGuid: string, updateMarketViewUserRequest?: UpdateMarketViewUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMarketViewUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMarketViewUser(marketViewUserGuid, updateMarketViewUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {boolean} isEnabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMarketViewUserEnabled(marketViewUserGuid: string, isEnabled: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMarketViewUserEnabled(marketViewUserGuid, isEnabled, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpsertEmailScheduleRequest} [upsertEmailScheduleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertEmailSchedule(upsertEmailScheduleRequest?: UpsertEmailScheduleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertEmailScheduleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertEmailSchedule(upsertEmailScheduleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MarketViewApi - factory interface
 * @export
 */
export const MarketViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketViewApiFp(configuration)
    return {
        /**
         * 
         * @param {string} siteName 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommodityManagementSite(siteName: string, companyGuid: string, options?: any): AxiosPromise<AddCommodityManagementSiteResponse> {
            return localVarFp.addCommodityManagementSite(siteName, companyGuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {string} [email] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {boolean} [isSiteManager] 
         * @param {Array<CommodityManagementUserPermissions>} [permissions] 
         * @param {boolean} [initializeAccessIfNew] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommodityManagementUserSiteAccess(siteGuid: string, marketViewUserGuid: string, email?: string, firstName?: string, lastName?: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, initializeAccessIfNew?: boolean, options?: any): AxiosPromise<object> {
            return localVarFp.addCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, email, firstName, lastName, isSiteManager, permissions, initializeAccessIfNew, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddCompanyRequest} [addCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompany(addCompanyRequest?: AddCompanyRequest, options?: any): AxiosPromise<AddCompanyResponse> {
            return localVarFp.addCompany(addCompanyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} savedQueryId 
         * @param {string} name 
         * @param {Array<MarkItViewQuerySavedParameters>} markItViewQuerySavedParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewSavedQuery(savedQueryId: number, name: string, markItViewQuerySavedParameters: Array<MarkItViewQuerySavedParameters>, options?: any): AxiosPromise<AddMarketViewSavedQueryResponse> {
            return localVarFp.addMarketViewSavedQuery(savedQueryId, name, markItViewQuerySavedParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddMarketViewUserRequest} [addMarketViewUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewUser(addMarketViewUserRequest?: AddMarketViewUserRequest, options?: any): AxiosPromise<AddMarketViewUserResponse> {
            return localVarFp.addMarketViewUser(addMarketViewUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {AddMarketViewUserFavoritedProductRequest} [addMarketViewUserFavoritedProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewUserFavoritedProduct(productId: string, addMarketViewUserFavoritedProductRequest?: AddMarketViewUserFavoritedProductRequest, options?: any): AxiosPromise<object> {
            return localVarFp.addMarketViewUserFavoritedProduct(productId, addMarketViewUserFavoritedProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userVolumeId 
         * @param {string} name 
         * @param {{ [key: string]: number; }} volumes 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewVolume(userVolumeId: number, name: string, volumes: { [key: string]: number; }, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<AddMarketViewVolumeResponse> {
            return localVarFp.addMarketViewVolume(userVolumeId, name, volumes, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AgreeToMarketViewTermsAndConditionsRequest} [agreeToMarketViewTermsAndConditionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreeToDemeterTermsAndConditions(agreeToMarketViewTermsAndConditionsRequest?: AgreeToMarketViewTermsAndConditionsRequest, options?: any): AxiosPromise<object> {
            return localVarFp.agreeToDemeterTermsAndConditions(agreeToMarketViewTermsAndConditionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CalculateMatrixRequest} [calculateMatrixRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateMatrix(calculateMatrixRequest?: CalculateMatrixRequest, options?: any): AxiosPromise<CalculateMatrixResponse> {
            return localVarFp.calculateMatrix(calculateMatrixRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {boolean} [disableUserIfNoOtherSites] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommodityManagementUserSiteAccess(siteGuid: string, marketViewUserGuid: string, disableUserIfNoOtherSites?: boolean, options?: any): AxiosPromise<object> {
            return localVarFp.deleteCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, disableUserIfNoOtherSites, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} emailScheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailSchedule(emailScheduleId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteEmailSchedule(emailScheduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarketViewSavedQuery(savedQueryId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteMarketViewSavedQuery(savedQueryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarketViewUserFavoritedProduct(productId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteMarketViewUserFavoritedProduct(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMarketViewSavedQuery(savedQueryId: string, options?: any): AxiosPromise<FileResponse> {
            return localVarFp.exportMarketViewSavedQuery(savedQueryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany(companyGuid: string, options?: any): AxiosPromise<GetCompanyResponse> {
            return localVarFp.getCompany(companyGuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveBasisPrices(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<Array<DecisiveMarketPriceModel>> {
            return localVarFp.getDecisiveBasisPrices(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveFutureBasisPricesRangeByCommodity(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<Array<DecisiveMarketPriceModel>> {
            return localVarFp.getDecisiveFutureBasisPricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveFuturePricesRangeByCommodity(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<Array<DecisiveMarketPriceModel>> {
            return localVarFp.getDecisiveFuturePricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveSpecialtyCropPricesRangeByCommodity(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<Array<DecisiveMarketPriceModel>> {
            return localVarFp.getDecisiveSpecialtyCropPricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [forecastHistoryYears] 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastInternal(productId: string, forecastHistoryYears?: number, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: any): AxiosPromise<GetForecastResponse> {
            return localVarFp.getForecastInternal(productId, forecastHistoryYears, quoteDate, recentHistoryDays, historicalMedianYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [forecastHistoryYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastWithHistory(productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: any): AxiosPromise<GetForecastWithHistoryResponse> {
            return localVarFp.getForecastWithHistory(productId, quoteDate, recentHistoryDays, historicalMedianYears, forecastHistoryYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [forecastHistoryYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastWithHistoryInternal(productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: any): AxiosPromise<GetForecastWithHistoryResponse> {
            return localVarFp.getForecastWithHistoryInternal(productId, quoteDate, recentHistoryDays, historicalMedianYears, forecastHistoryYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketViewLastQuoteDate(symbolId: string, asOfDate?: string, options?: any): AxiosPromise<GetMarketViewLastQuoteDateResponse> {
            return localVarFp.getMarketViewLastQuoteDate(symbolId, asOfDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketViewLastQuoteDateApi(symbolId: string, asOfDate?: string, options?: any): AxiosPromise<GetMarketViewLastQuoteDateResponse> {
            return localVarFp.getMarketViewLastQuoteDateApi(symbolId, asOfDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {string} [stoneXUserGuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketViewUser(marketViewUserGuid: string, stoneXUserGuid?: string, options?: any): AxiosPromise<GetMarketViewUserResponse> {
            return localVarFp.getMarketViewUser(marketViewUserGuid, stoneXUserGuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommodityManagementSiteUsers(siteGuid: string, options?: any): AxiosPromise<ListCommodityManagementSiteUsersResponse> {
            return localVarFp.listCommodityManagementSiteUsers(siteGuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [includeUserSiteAccess] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommodityManagementSites(includeUserSiteAccess?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListCommodityManagementSitesResponse> {
            return localVarFp.listCommodityManagementSites(includeUserSiteAccess, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanies(sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListCompaniesResponse> {
            return localVarFp.listCompanies(sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmailScheduleSource} [source] 
         * @param {number} [sourceId] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmailSchedules(source?: EmailScheduleSource, sourceId?: number, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListEmailSchedulesResponse> {
            return localVarFp.listEmailSchedules(source, sourceId, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ListMarketViewContractPricesRequest} [listMarketViewContractPricesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewContractPricesApi(listMarketViewContractPricesRequest?: ListMarketViewContractPricesRequest, options?: any): AxiosPromise<ListMarketViewContractPricesResponse> {
            return localVarFp.listMarketViewContractPricesApi(listMarketViewContractPricesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {Array<Currency>} currencies 
         * @param {Array<ContractDate>} contractMonths 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewCurrencySpotRates(quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options?: any): AxiosPromise<ListMarketViewCurrencySpotRatesResponse> {
            return localVarFp.listMarketViewCurrencySpotRates(quoteDate, currencies, contractMonths, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {Array<Currency>} currencies 
         * @param {Array<ContractDate>} contractMonths 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewCurrencySpotRatesApi(quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options?: any): AxiosPromise<ListMarketViewCurrencySpotRatesResponse> {
            return localVarFp.listMarketViewCurrencySpotRatesApi(quoteDate, currencies, contractMonths, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewDailyPrices(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQueryDailyPricesResponse> {
            return localVarFp.listMarketViewDailyPrices(productId, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} productIds 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewExpirationDates(productIds: Array<number>, refreshCache?: boolean, options?: any): AxiosPromise<ListMarketViewExpirationDatesResponse> {
            return localVarFp.listMarketViewExpirationDates(productIds, refreshCache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} productIds 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewExpirationDatesApi(productIds: Array<number>, refreshCache?: boolean, options?: any): AxiosPromise<ListMarketViewExpirationDatesResponse> {
            return localVarFp.listMarketViewExpirationDatesApi(productIds, refreshCache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} quoteDate 
         * @param {number} [numberOfMonths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewForwardCurveQuery(productId: string, quoteDate: string, numberOfMonths?: number, options?: any): AxiosPromise<MarketViewQueryForwardCurveResponse> {
            return localVarFp.listMarketViewForwardCurveQuery(productId, quoteDate, numberOfMonths, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} quoteDate 
         * @param {number} [numberOfMonths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewForwardCurveQueryApi(productId: string, quoteDate: string, numberOfMonths?: number, options?: any): AxiosPromise<MarketViewQueryForwardCurveResponse> {
            return localVarFp.listMarketViewForwardCurveQueryApi(productId, quoteDate, numberOfMonths, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} symbolIds 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewLastQuoteDate(symbolIds: Array<number>, asOfDate?: string, options?: any): AxiosPromise<ListMarketViewLastQuoteDateResponse> {
            return localVarFp.listMarketViewLastQuoteDate(symbolIds, asOfDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} symbolIds 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewLastQuoteDateApi(symbolIds: Array<number>, asOfDate?: string, options?: any): AxiosPromise<ListMarketViewLastQuoteDateResponse> {
            return localVarFp.listMarketViewLastQuoteDateApi(symbolIds, asOfDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryCalendarStripAvearge(productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options?: any): AxiosPromise<MarketViewQueryCalendarStripAverageResponse> {
            return localVarFp.listMarketViewPriceQueryCalendarStripAvearge(productId, years, quoteDateRangeStart, quoteDateRangeEnd, userVolumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryCalendarStripAverageApi(productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options?: any): AxiosPromise<MarketViewQueryCalendarStripAverageResponse> {
            return localVarFp.listMarketViewPriceQueryCalendarStripAverageApi(productId, years, quoteDateRangeStart, quoteDateRangeEnd, userVolumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} monthsAhead 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryRollingMonthAhead(productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQueryRollingMonthAheadResponse> {
            return localVarFp.listMarketViewPriceQueryRollingMonthAhead(productId, monthsAhead, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} monthsAhead 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryRollingMonthAheadApi(productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQueryRollingMonthAheadResponse> {
            return localVarFp.listMarketViewPriceQueryRollingMonthAheadApi(productId, monthsAhead, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPrices(productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQueryPriceResponse> {
            return localVarFp.listMarketViewPrices(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesApi(productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQueryPriceResponse> {
            return localVarFp.listMarketViewPricesApi(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} contractYear 
         * @param {string} contractMonth 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesBySymbol(symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListMarketViewPricesResponse> {
            return localVarFp.listMarketViewPricesBySymbol(symbolId, contractYear, contractMonth, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} contractYear 
         * @param {string} contractMonth 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesBySymbolApi(symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListMarketViewPricesResponse> {
            return localVarFp.listMarketViewPricesBySymbolApi(symbolId, contractYear, contractMonth, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesInternal(productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQueryPriceResponse> {
            return localVarFp.listMarketViewPricesInternal(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [contractDateRangeStartYear] 
         * @param {number} [contractDateRangeStartMonth] 
         * @param {number} [contractDateRangeEndYear] 
         * @param {number} [contractDateRangeEndMonth] 
         * @param {number} [contractDateRangeStartContractDateYear] 
         * @param {number} [contractDateRangeStartContractDateMonth] 
         * @param {string} [contractDateRangeStartContractDateLabel] 
         * @param {number} [contractDateRangeEndContractDateYear] 
         * @param {number} [contractDateRangeEndContractDateMonth] 
         * @param {string} [contractDateRangeEndContractDateLabel] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesStripAverage(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options?: any): AxiosPromise<MarketViewQueryStripAverageResponse> {
            return localVarFp.listMarketViewPricesStripAverage(productId, quoteDateRangeStart, quoteDateRangeEnd, contractDateRangeStartYear, contractDateRangeStartMonth, contractDateRangeEndYear, contractDateRangeEndMonth, contractDateRangeStartContractDateYear, contractDateRangeStartContractDateMonth, contractDateRangeStartContractDateLabel, contractDateRangeEndContractDateYear, contractDateRangeEndContractDateMonth, contractDateRangeEndContractDateLabel, userVolumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [contractDateRangeStartYear] 
         * @param {number} [contractDateRangeStartMonth] 
         * @param {number} [contractDateRangeEndYear] 
         * @param {number} [contractDateRangeEndMonth] 
         * @param {number} [contractDateRangeStartContractDateYear] 
         * @param {number} [contractDateRangeStartContractDateMonth] 
         * @param {string} [contractDateRangeStartContractDateLabel] 
         * @param {number} [contractDateRangeEndContractDateYear] 
         * @param {number} [contractDateRangeEndContractDateMonth] 
         * @param {string} [contractDateRangeEndContractDateLabel] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesStripAverageApi(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options?: any): AxiosPromise<MarketViewQueryStripAverageResponse> {
            return localVarFp.listMarketViewPricesStripAverageApi(productId, quoteDateRangeStart, quoteDateRangeEnd, contractDateRangeStartYear, contractDateRangeStartMonth, contractDateRangeEndYear, contractDateRangeEndMonth, contractDateRangeStartContractDateYear, contractDateRangeStartContractDateMonth, contractDateRangeStartContractDateLabel, contractDateRangeEndContractDateYear, contractDateRangeEndContractDateMonth, contractDateRangeEndContractDateLabel, userVolumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewProductTypes(options?: any): AxiosPromise<ListMarketViewProductTypesResponse> {
            return localVarFp.listMarketViewProductTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommodityType} [commodityType] 
         * @param {Array<number>} [productIds] 
         * @param {number} [minimumHistoryYears] 
         * @param {number} [lastQuoteDateThresholdDays] 
         * @param {boolean} [refreshCache] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewProducts(commodityType?: CommodityType, productIds?: Array<number>, minimumHistoryYears?: number, lastQuoteDateThresholdDays?: number, refreshCache?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListMarketViewProductsResponse> {
            return localVarFp.listMarketViewProducts(commodityType, productIds, minimumHistoryYears, lastQuoteDateThresholdDays, refreshCache, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommodityType} [commodityType] 
         * @param {PriceType} [priceType] 
         * @param {Array<number>} [productIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewProductsInternal(commodityType?: CommodityType, priceType?: PriceType, productIds?: Array<number>, options?: any): AxiosPromise<ListMarketViewInternalProductsResponse> {
            return localVarFp.listMarketViewProductsInternal(commodityType, priceType, productIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewSavedQuery(sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListMarketViewSavedQueryResponse> {
            return localVarFp.listMarketViewSavedQuery(sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewSettlementPrices(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQuerySettlementsResponse> {
            return localVarFp.listMarketViewSettlementPrices(productId, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewSettlementPricesApi(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQuerySettlementsResponse> {
            return localVarFp.listMarketViewSettlementPricesApi(productId, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [marketViewUserGuids] 
         * @param {string} [companyGuid] 
         * @param {boolean} [includeSites] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewUsers(marketViewUserGuids?: Array<string>, companyGuid?: string, includeSites?: boolean, options?: any): AxiosPromise<ListMarketViewUsersResponse> {
            return localVarFp.listMarketViewUsers(marketViewUserGuids, companyGuid, includeSites, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewVolumes(options?: any): AxiosPromise<MarketViewVolumesResponse> {
            return localVarFp.listMarketViewVolumes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketViewProductTradingMonths(productId: string, options?: any): AxiosPromise<MarketViewProductTradingMonthsResponse> {
            return localVarFp.marketViewProductTradingMonths(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketViewUserAuthorizationCallback(options?: any): AxiosPromise<GetMarketViewUserAuthorizationResponse> {
            return localVarFp.marketViewUserAuthorizationCallback(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} emailScheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailScheduleNow(emailScheduleId: string, options?: any): AxiosPromise<SendEmailScheduleResponse> {
            return localVarFp.sendEmailScheduleNow(emailScheduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {SendMarketViewSavedQueryEmailRequest} [sendMarketViewSavedQueryEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMarketViewSavedQueryEmail(savedQueryId: string, sendMarketViewSavedQueryEmailRequest?: SendMarketViewSavedQueryEmailRequest, options?: any): AxiosPromise<SendMarketViewSavedQueryEmailResponse> {
            return localVarFp.sendMarketViewSavedQueryEmail(savedQueryId, sendMarketViewSavedQueryEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} siteName 
         * @param {string} companyGuid 
         * @param {Array<UserAccessUpdateModel>} userSiteAccesses 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommodityManagementSite(siteGuid: string, siteName: string, companyGuid: string, userSiteAccesses: Array<UserAccessUpdateModel>, options?: any): AxiosPromise<UpdateCommodityManagementSiteResponse> {
            return localVarFp.updateCommodityManagementSite(siteGuid, siteName, companyGuid, userSiteAccesses, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {boolean} [isSiteManager] 
         * @param {Array<CommodityManagementUserPermissions>} [permissions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommodityManagementUserSiteAccess(siteGuid: string, marketViewUserGuid: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, options?: any): AxiosPromise<object> {
            return localVarFp.updateCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, isSiteManager, permissions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {UpdateCompanyRequest} [updateCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany(companyGuid: string, updateCompanyRequest?: UpdateCompanyRequest, options?: any): AxiosPromise<UpdateCompanyResponse> {
            return localVarFp.updateCompany(companyGuid, updateCompanyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {boolean} isEnabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyEnabled(companyGuid: string, isEnabled: boolean, options?: any): AxiosPromise<object> {
            return localVarFp.updateCompanyEnabled(companyGuid, isEnabled, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {UpdateMarketViewUserRequest} [updateMarketViewUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketViewUser(marketViewUserGuid: string, updateMarketViewUserRequest?: UpdateMarketViewUserRequest, options?: any): AxiosPromise<UpdateMarketViewUserResponse> {
            return localVarFp.updateMarketViewUser(marketViewUserGuid, updateMarketViewUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {boolean} isEnabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketViewUserEnabled(marketViewUserGuid: string, isEnabled: boolean, options?: any): AxiosPromise<object> {
            return localVarFp.updateMarketViewUserEnabled(marketViewUserGuid, isEnabled, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertEmailScheduleRequest} [upsertEmailScheduleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertEmailSchedule(upsertEmailScheduleRequest?: UpsertEmailScheduleRequest, options?: any): AxiosPromise<UpsertEmailScheduleResponse> {
            return localVarFp.upsertEmailSchedule(upsertEmailScheduleRequest, options).then((request) => request(axios, basePath));
        },
    };
};



/**
 * MarketViewApi - object-oriented interface
 * @export
 * @class MarketViewApi
 * @extends {BaseAPI}
 */
export class MarketViewApi extends BaseAPI {
    /**
     * 
     * @param {string} siteName 
     * @param {string} companyGuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public addCommodityManagementSite(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), siteName: string, companyGuid: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).addCommodityManagementSite(siteName, companyGuid, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} siteGuid 
     * @param {string} marketViewUserGuid 
     * @param {string} [email] 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {boolean} [isSiteManager] 
     * @param {Array<CommodityManagementUserPermissions>} [permissions] 
     * @param {boolean} [initializeAccessIfNew] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public addCommodityManagementUserSiteAccess(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), siteGuid: string, marketViewUserGuid: string, email?: string, firstName?: string, lastName?: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, initializeAccessIfNew?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).addCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, email, firstName, lastName, isSiteManager, permissions, initializeAccessIfNew, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {AddCompanyRequest} [addCompanyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public addCompany(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), addCompanyRequest?: AddCompanyRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).addCompany(addCompanyRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {number} savedQueryId 
     * @param {string} name 
     * @param {Array<MarkItViewQuerySavedParameters>} markItViewQuerySavedParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public addMarketViewSavedQuery(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), savedQueryId: number, name: string, markItViewQuerySavedParameters: Array<MarkItViewQuerySavedParameters>, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).addMarketViewSavedQuery(savedQueryId, name, markItViewQuerySavedParameters, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {AddMarketViewUserRequest} [addMarketViewUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public addMarketViewUser(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), addMarketViewUserRequest?: AddMarketViewUserRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).addMarketViewUser(addMarketViewUserRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {AddMarketViewUserFavoritedProductRequest} [addMarketViewUserFavoritedProductRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public addMarketViewUserFavoritedProduct(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, addMarketViewUserFavoritedProductRequest?: AddMarketViewUserFavoritedProductRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).addMarketViewUserFavoritedProduct(productId, addMarketViewUserFavoritedProductRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {number} userVolumeId 
     * @param {string} name 
     * @param {{ [key: string]: number; }} volumes 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public addMarketViewVolume(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), userVolumeId: number, name: string, volumes: { [key: string]: number; }, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).addMarketViewVolume(userVolumeId, name, volumes, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {AgreeToMarketViewTermsAndConditionsRequest} [agreeToMarketViewTermsAndConditionsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public agreeToDemeterTermsAndConditions(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), agreeToMarketViewTermsAndConditionsRequest?: AgreeToMarketViewTermsAndConditionsRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).agreeToDemeterTermsAndConditions(agreeToMarketViewTermsAndConditionsRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {CalculateMatrixRequest} [calculateMatrixRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public calculateMatrix(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), calculateMatrixRequest?: CalculateMatrixRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).calculateMatrix(calculateMatrixRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} siteGuid 
     * @param {string} marketViewUserGuid 
     * @param {boolean} [disableUserIfNoOtherSites] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public deleteCommodityManagementUserSiteAccess(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), siteGuid: string, marketViewUserGuid: string, disableUserIfNoOtherSites?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).deleteCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, disableUserIfNoOtherSites, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} emailScheduleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public deleteEmailSchedule(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), emailScheduleId: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).deleteEmailSchedule(emailScheduleId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} savedQueryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public deleteMarketViewSavedQuery(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), savedQueryId: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).deleteMarketViewSavedQuery(savedQueryId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public deleteMarketViewUserFavoritedProduct(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).deleteMarketViewUserFavoritedProduct(productId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} savedQueryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public exportMarketViewSavedQuery(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), savedQueryId: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).exportMarketViewSavedQuery(savedQueryId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} companyGuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getCompany(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), companyGuid: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getCompany(companyGuid, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {string} commodity 
     * @param {string} [markToMarketDate] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getDecisiveBasisPrices(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getDecisiveBasisPrices(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {string} commodity 
     * @param {string} [markToMarketDate] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getDecisiveFutureBasisPricesRangeByCommodity(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getDecisiveFutureBasisPricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {string} commodity 
     * @param {string} [markToMarketDate] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getDecisiveFuturePricesRangeByCommodity(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getDecisiveFuturePricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {string} commodity 
     * @param {string} [markToMarketDate] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getDecisiveSpecialtyCropPricesRangeByCommodity(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getDecisiveSpecialtyCropPricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {number} [forecastHistoryYears] 
     * @param {string} [quoteDate] 
     * @param {number} [recentHistoryDays] 
     * @param {number} [historicalMedianYears] 
     * @param {number} [startContractDateYear] 
     * @param {number} [startContractDateMonth] 
     * @param {string} [startContractDateLabel] 
     * @param {number} [monthsAhead] 
     * @param {boolean} [applyPpi] 
     * @param {boolean} [refreshCache] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getForecastInternal(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, forecastHistoryYears?: number, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getForecastInternal(productId, forecastHistoryYears, quoteDate, recentHistoryDays, historicalMedianYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [quoteDate] 
     * @param {number} [recentHistoryDays] 
     * @param {number} [historicalMedianYears] 
     * @param {number} [forecastHistoryYears] 
     * @param {number} [startContractDateYear] 
     * @param {number} [startContractDateMonth] 
     * @param {string} [startContractDateLabel] 
     * @param {number} [monthsAhead] 
     * @param {boolean} [applyPpi] 
     * @param {boolean} [refreshCache] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getForecastWithHistory(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getForecastWithHistory(productId, quoteDate, recentHistoryDays, historicalMedianYears, forecastHistoryYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [quoteDate] 
     * @param {number} [recentHistoryDays] 
     * @param {number} [historicalMedianYears] 
     * @param {number} [forecastHistoryYears] 
     * @param {number} [startContractDateYear] 
     * @param {number} [startContractDateMonth] 
     * @param {string} [startContractDateLabel] 
     * @param {number} [monthsAhead] 
     * @param {boolean} [applyPpi] 
     * @param {boolean} [refreshCache] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getForecastWithHistoryInternal(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getForecastWithHistoryInternal(productId, quoteDate, recentHistoryDays, historicalMedianYears, forecastHistoryYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} symbolId 
     * @param {string} [asOfDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getMarketViewLastQuoteDate(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), symbolId: string, asOfDate?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getMarketViewLastQuoteDate(symbolId, asOfDate, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} symbolId 
     * @param {string} [asOfDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getMarketViewLastQuoteDateApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), symbolId: string, asOfDate?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getMarketViewLastQuoteDateApi(symbolId, asOfDate, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} marketViewUserGuid 
     * @param {string} [stoneXUserGuid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getMarketViewUser(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), marketViewUserGuid: string, stoneXUserGuid?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getMarketViewUser(marketViewUserGuid, stoneXUserGuid, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} siteGuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listCommodityManagementSiteUsers(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), siteGuid: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listCommodityManagementSiteUsers(siteGuid, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {boolean} [includeUserSiteAccess] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listCommodityManagementSites(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), includeUserSiteAccess?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listCommodityManagementSites(includeUserSiteAccess, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listCompanies(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listCompanies(sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {EmailScheduleSource} [source] 
     * @param {number} [sourceId] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listEmailSchedules(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), source?: EmailScheduleSource, sourceId?: number, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listEmailSchedules(source, sourceId, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {ListMarketViewContractPricesRequest} [listMarketViewContractPricesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewContractPricesApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), listMarketViewContractPricesRequest?: ListMarketViewContractPricesRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewContractPricesApi(listMarketViewContractPricesRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} quoteDate 
     * @param {Array<Currency>} currencies 
     * @param {Array<ContractDate>} contractMonths 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewCurrencySpotRates(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewCurrencySpotRates(quoteDate, currencies, contractMonths, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} quoteDate 
     * @param {Array<Currency>} currencies 
     * @param {Array<ContractDate>} contractMonths 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewCurrencySpotRatesApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewCurrencySpotRatesApi(quoteDate, currencies, contractMonths, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewDailyPrices(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewDailyPrices(productId, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {Array<number>} productIds 
     * @param {boolean} [refreshCache] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewExpirationDates(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productIds: Array<number>, refreshCache?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewExpirationDates(productIds, refreshCache, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {Array<number>} productIds 
     * @param {boolean} [refreshCache] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewExpirationDatesApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productIds: Array<number>, refreshCache?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewExpirationDatesApi(productIds, refreshCache, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} quoteDate 
     * @param {number} [numberOfMonths] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewForwardCurveQuery(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDate: string, numberOfMonths?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewForwardCurveQuery(productId, quoteDate, numberOfMonths, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} quoteDate 
     * @param {number} [numberOfMonths] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewForwardCurveQueryApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDate: string, numberOfMonths?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewForwardCurveQueryApi(productId, quoteDate, numberOfMonths, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {Array<number>} symbolIds 
     * @param {string} [asOfDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewLastQuoteDate(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), symbolIds: Array<number>, asOfDate?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewLastQuoteDate(symbolIds, asOfDate, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {Array<number>} symbolIds 
     * @param {string} [asOfDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewLastQuoteDateApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), symbolIds: Array<number>, asOfDate?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewLastQuoteDateApi(symbolIds, asOfDate, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {Array<number>} years 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {number} [userVolumeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPriceQueryCalendarStripAvearge(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPriceQueryCalendarStripAvearge(productId, years, quoteDateRangeStart, quoteDateRangeEnd, userVolumeId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {Array<number>} years 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {number} [userVolumeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPriceQueryCalendarStripAverageApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPriceQueryCalendarStripAverageApi(productId, years, quoteDateRangeStart, quoteDateRangeEnd, userVolumeId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {number} monthsAhead 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPriceQueryRollingMonthAhead(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPriceQueryRollingMonthAhead(productId, monthsAhead, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {number} monthsAhead 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPriceQueryRollingMonthAheadApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPriceQueryRollingMonthAheadApi(productId, monthsAhead, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {Array<number>} years 
     * @param {Array<number>} months 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPrices(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPrices(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {Array<number>} years 
     * @param {Array<number>} months 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPricesApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPricesApi(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} symbolId 
     * @param {string} contractYear 
     * @param {string} contractMonth 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPricesBySymbol(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPricesBySymbol(symbolId, contractYear, contractMonth, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} symbolId 
     * @param {string} contractYear 
     * @param {string} contractMonth 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPricesBySymbolApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPricesBySymbolApi(symbolId, contractYear, contractMonth, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {Array<number>} years 
     * @param {Array<number>} months 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPricesInternal(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPricesInternal(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {number} [contractDateRangeStartYear] 
     * @param {number} [contractDateRangeStartMonth] 
     * @param {number} [contractDateRangeEndYear] 
     * @param {number} [contractDateRangeEndMonth] 
     * @param {number} [contractDateRangeStartContractDateYear] 
     * @param {number} [contractDateRangeStartContractDateMonth] 
     * @param {string} [contractDateRangeStartContractDateLabel] 
     * @param {number} [contractDateRangeEndContractDateYear] 
     * @param {number} [contractDateRangeEndContractDateMonth] 
     * @param {string} [contractDateRangeEndContractDateLabel] 
     * @param {number} [userVolumeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPricesStripAverage(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPricesStripAverage(productId, quoteDateRangeStart, quoteDateRangeEnd, contractDateRangeStartYear, contractDateRangeStartMonth, contractDateRangeEndYear, contractDateRangeEndMonth, contractDateRangeStartContractDateYear, contractDateRangeStartContractDateMonth, contractDateRangeStartContractDateLabel, contractDateRangeEndContractDateYear, contractDateRangeEndContractDateMonth, contractDateRangeEndContractDateLabel, userVolumeId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {number} [contractDateRangeStartYear] 
     * @param {number} [contractDateRangeStartMonth] 
     * @param {number} [contractDateRangeEndYear] 
     * @param {number} [contractDateRangeEndMonth] 
     * @param {number} [contractDateRangeStartContractDateYear] 
     * @param {number} [contractDateRangeStartContractDateMonth] 
     * @param {string} [contractDateRangeStartContractDateLabel] 
     * @param {number} [contractDateRangeEndContractDateYear] 
     * @param {number} [contractDateRangeEndContractDateMonth] 
     * @param {string} [contractDateRangeEndContractDateLabel] 
     * @param {number} [userVolumeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPricesStripAverageApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPricesStripAverageApi(productId, quoteDateRangeStart, quoteDateRangeEnd, contractDateRangeStartYear, contractDateRangeStartMonth, contractDateRangeEndYear, contractDateRangeEndMonth, contractDateRangeStartContractDateYear, contractDateRangeStartContractDateMonth, contractDateRangeStartContractDateLabel, contractDateRangeEndContractDateYear, contractDateRangeEndContractDateMonth, contractDateRangeEndContractDateLabel, userVolumeId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewProductTypes(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewProductTypes(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {CommodityType} [commodityType] 
     * @param {Array<number>} [productIds] 
     * @param {number} [minimumHistoryYears] 
     * @param {number} [lastQuoteDateThresholdDays] 
     * @param {boolean} [refreshCache] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewProducts(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), commodityType?: CommodityType, productIds?: Array<number>, minimumHistoryYears?: number, lastQuoteDateThresholdDays?: number, refreshCache?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewProducts(commodityType, productIds, minimumHistoryYears, lastQuoteDateThresholdDays, refreshCache, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {CommodityType} [commodityType] 
     * @param {PriceType} [priceType] 
     * @param {Array<number>} [productIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewProductsInternal(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), commodityType?: CommodityType, priceType?: PriceType, productIds?: Array<number>, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewProductsInternal(commodityType, priceType, productIds, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewSavedQuery(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewSavedQuery(sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewSettlementPrices(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewSettlementPrices(productId, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewSettlementPricesApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewSettlementPricesApi(productId, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {Array<string>} [marketViewUserGuids] 
     * @param {string} [companyGuid] 
     * @param {boolean} [includeSites] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewUsers(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), marketViewUserGuids?: Array<string>, companyGuid?: string, includeSites?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewUsers(marketViewUserGuids, companyGuid, includeSites, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewVolumes(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewVolumes(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public marketViewProductTradingMonths(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).marketViewProductTradingMonths(productId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public marketViewUserAuthorizationCallback(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).marketViewUserAuthorizationCallback(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} emailScheduleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public sendEmailScheduleNow(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), emailScheduleId: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).sendEmailScheduleNow(emailScheduleId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} savedQueryId 
     * @param {SendMarketViewSavedQueryEmailRequest} [sendMarketViewSavedQueryEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public sendMarketViewSavedQueryEmail(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), savedQueryId: string, sendMarketViewSavedQueryEmailRequest?: SendMarketViewSavedQueryEmailRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).sendMarketViewSavedQueryEmail(savedQueryId, sendMarketViewSavedQueryEmailRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} siteGuid 
     * @param {string} siteName 
     * @param {string} companyGuid 
     * @param {Array<UserAccessUpdateModel>} userSiteAccesses 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public updateCommodityManagementSite(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), siteGuid: string, siteName: string, companyGuid: string, userSiteAccesses: Array<UserAccessUpdateModel>, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).updateCommodityManagementSite(siteGuid, siteName, companyGuid, userSiteAccesses, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} siteGuid 
     * @param {string} marketViewUserGuid 
     * @param {boolean} [isSiteManager] 
     * @param {Array<CommodityManagementUserPermissions>} [permissions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public updateCommodityManagementUserSiteAccess(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), siteGuid: string, marketViewUserGuid: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).updateCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, isSiteManager, permissions, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} companyGuid 
     * @param {UpdateCompanyRequest} [updateCompanyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public updateCompany(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), companyGuid: string, updateCompanyRequest?: UpdateCompanyRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).updateCompany(companyGuid, updateCompanyRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} companyGuid 
     * @param {boolean} isEnabled 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public updateCompanyEnabled(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), companyGuid: string, isEnabled: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).updateCompanyEnabled(companyGuid, isEnabled, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} marketViewUserGuid 
     * @param {UpdateMarketViewUserRequest} [updateMarketViewUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public updateMarketViewUser(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), marketViewUserGuid: string, updateMarketViewUserRequest?: UpdateMarketViewUserRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).updateMarketViewUser(marketViewUserGuid, updateMarketViewUserRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} marketViewUserGuid 
     * @param {boolean} isEnabled 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public updateMarketViewUserEnabled(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), marketViewUserGuid: string, isEnabled: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).updateMarketViewUserEnabled(marketViewUserGuid, isEnabled, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {UpsertEmailScheduleRequest} [upsertEmailScheduleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public upsertEmailSchedule(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), upsertEmailScheduleRequest?: UpsertEmailScheduleRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).upsertEmailSchedule(upsertEmailScheduleRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }
}


